import Icon from './Icons';
import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';

import state from '../state';
import ColorSetter from './NewColorPicker';
import ImageUploader from './ImageUploader';
import GKEvent from '../events';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Switch from '@material-ui/core/Switch';

import DragSortableList from './DraggableElement';
import SlideDialog from './SlideDialog';
import ListDialog from './ListDialog';
import { Select, TextField } from './FormElements';
import SliderRange from './SliderRange';

import { validURL, inArray, generateStyle, l, getLangLabel, pagesOptions, isObject } from '../functions';
import ListSortedItemsCheckboxes from './ListSortedItemsCheckboxes';
import ProductFilter from './ProductFilter';
import { ajaxUri } from '../consts/index';
import { fontList as globalFontList } from '../consts/fonts';
import iconList from '../consts/iconsList';
import isEqual from 'lodash/isEqual';
import NewColorPicker from './NewColorPicker';
function isValidMobile(number) {
  const regex = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
  return regex.test(number);
}

const mapStateToProps = (state) => {
  return {
    elementToEdit: state.rootReducer.elementToEdit || null,
    fetchedPages: state.rootReducer.fetchedPages || [],
    fetchedProducts: state.rootReducer.fetchedProducts || [],
    fetchedCategories: state.rootReducer.fetchedCategories || [],
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || 'xl',
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
    showBlockSettings: state.rootReducer.showBlockSettings ?? false,
    settings: state.rootReducer.appearanceSettings || {},
    showGlobalList: state.rootReducer.showGlobalList ?? true,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editElement: (element) => dispatch({ type: 'EDIT_ELEMENT', element }),
    setShowBlockSettings: () => dispatch({ type: 'SHOW_BLOCK_SETTINGS', showBlockSettings: false }),
    setSettingsOpen: () =>
      dispatch({
        type: 'SET_FLOAT_SETTINGS_OPEN',
        openFloatElementSettings: false,
      }),
    setShowGlobalList: (show) =>
      dispatch({
        type: 'SET_SHOW_GLOBALE_LIST',
        show: show,
      }),
  };
};

function prettifySortItem(ids = [], labels, key, element) {
  let idsList = [];

  let i = 1;

  ids.forEach((id) => {
    idsList.push({
      id: id,
      content: (labels[id] && labels[id][key]) || element + ' ' + l('is missing'),
      rank: i,
    });

    i++;
  });

  return idsList;
}

function optionLoop(from = 0, to = 100, prevText = '', nextText = '') {
  let options = [];

  if (prevText !== '') prevText = prevText + ' ';

  if (nextText !== '') nextText = nextText + ' ';

  for (let i = from; i <= to; i++) {
    options.push({
      label: prevText + i + nextText,
      value: i,
    });
  }

  return options;
}

function newDraggableElement(elements = [], index, label, cb = () => {}) {
  const Id = Math.floor(Math.random() * 999999 + 9999);

  const content = {
    id: Id.toString(),
    content: label + ' ' + parseInt(elements.length + 1),
    data: null,
    rank: elements.length,
  };

  let newElements = [];

  if (elements) newElements = elements.concat([content]);
  else newElements = [content];

  cb(newElements);
}

function newTabItem(elements = [], index, label, cb = () => {}) {
  const Id = Math.floor(Math.random() * 999999 + 9999);
  const content = {
    id: Id.toString(),
    data: {
      title_1: label + ' ' + parseInt(elements.length + 1),
    },
    rank: elements.length,
  };
  let newElements = [];

  if (elements) newElements = elements.concat([content]);
  else newElements = [content];

  cb(newElements);
}

class FloatElementSettings extends Component {
  constructor(props) {
    super(props);

    this.defaultSettings = {
      background: {
        backgroundImage: null,
        backgroundColor: null,
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center center',
      },
      border: {
        borderLeft: null,
        borderTop: null,
        borderRight: null,
        borderBottom: null,
      },
      spacing: null,
      text: null,
      alignment: null,
    };

    this.defaultState = {
      currentDrop: 0,
      current_style: null,
      currentTab: 1,
      slideDialog: null,
      selectedFields: {},
      selectedFieldsValue: {},
      globalSettings: {},
      url: '',
      advanceSettings: false,
      showAppearance: false,
      hideAdvanceSettings: false,
      showAppearanceMessage: true,
      tabDialog: null,
    };

    this.state = {
      ...this.defaultState,
      ...{
        listDatas: null,
        styles: [],
        datas: {},
        settings: this.defaultSettings,
      },
    };

    this.fontList = globalFontList;

    this.weightLabel = {
      200: 'Extra light',
      300: 'Light',
      400: 'Regular',
      500: 'Medium',
      600: 'Semi bold',
      700: 'Bold',
      800: 'Extra bold',
      900: 'Black',
    };

    this.animations = [
      {
        label: 'Bounce',
        value: 'bounce animated',
      },
      {
        label: 'Flash',
        value: 'flash animated',
      },
      {
        label: 'Pulse',
        value: 'pulse animated',
      },
      {
        label: 'Rubber Band',
        value: 'rubberBand animated',
      },
      {
        label: 'Shake',
        value: 'shake animated',
      },
      {
        label: 'Swing',
        value: 'swing animated',
      },
      {
        label: 'Tada',
        value: 'tada animated',
      },
      {
        label: 'Wobble',
        value: 'wobble animated',
      },
      {
        label: 'Jello',
        value: 'jello animated',
      },
      {
        label: 'Heart Beat',
        value: 'heartBeat animated',
      },
      {
        label: 'Bounce In',
        value: 'bounceIn animated',
      },
      {
        label: 'Bounce Out',
        value: 'bounceOut animated',
      },
      {
        label: 'Fade In',
        value: 'fadeIn animated',
      },
      {
        label: 'Fade Out',
        value: 'fadeOut animated',
      },
      {
        label: 'Zoom In',
        value: 'zoomIn animated',
      },
      {
        label: 'Zoom Out',
        value: 'zoomOut animated',
      },
      {
        label: 'Jack In The Box',
        value: 'jackInTheBox animated',
      },
    ];

    this.customFields = [
      { label: 'Before', value: 0 },
      { label: 'After', value: 1 },
    ];

    this.deviceLabel = {
      xs: l('Mobiles'),
      sm: l('Small tabs'),
      md: l('Large tabs'),
      lg: l('Small screens'),
      xl: l('Large screens'),
    };
  }

  componentDidMount() {
    this._getStyles();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (prevState.settings !== this.state.settings && this.state.settings !== null) ||
      (prevState.datas !== this.state.datas && this.state.datas !== null)
    ) {
      const { elementToEdit } = this.props;
      if (elementToEdit !== null) {
        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } = state.getFullElement(id, dropzoneID, parentID);

        let settingsIndex = 'settings';

        if (this.props.currentDevice !== 'xl') settingsIndex = settingsIndex + '-' + this.props.currentDevice;

        const newPlayload = {
          ...payload,
          [settingsIndex]: this.state.settings,
          datas: this.state.datas,
        };

        state.updateElement(id, dropzoneID, parentID, {
          payload: newPlayload,
        });
      }
    }
  }

  componentWillReceiveProps({ elementToEdit, currentDevice, showBlockSettings, appearanceSettings }) {
    if (elementToEdit === null) {
      this.setState(this.defaultState);
    } else {
      const oldElement = this.props.elementToEdit;

      if (elementToEdit.type == 'row') {
        this.setState({
          hideAdvanceSettings: true,
          advanceSettings: true,
          showAppearanceMessage: false,
        });
      } else {
        this.setState({
          hideAdvanceSettings: false,
          advanceSettings: false,
          showAppearanceMessage: true,
        });
      }
      this.setState({ showAppearance: false });

      if (['image'].includes(elementToEdit.type)) {
        this.setState({ showAppearanceMessage: false });
      } else {
        this.setState({ showAppearanceMessage: true });
      }

      if (
        (oldElement === null ||
          elementToEdit.id !== oldElement.id ||
          this.props.currentDevice !== currentDevice ||
          showBlockSettings) &&
        isObject(elementToEdit)
      ) {
        let datasIndex = 'datas';
        let settingsIndex = 'settings';

        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } = state.getFullElement(id, dropzoneID, parentID) || {};

        if (currentDevice !== 'xl') {
          datasIndex = datasIndex + '-' + currentDevice;
          settingsIndex = settingsIndex + '-' + currentDevice;
        }

        let currentSettings = elementToEdit?.payload[settingsIndex] || elementToEdit?.payload?.settings || {};
        if (payload) currentSettings = payload[settingsIndex] || payload.settings;

        let currentDatas = elementToEdit.payload.datas || {};
        if (payload) currentDatas = payload?.datas || {};

        const oldDatas = this.props.datas;

        this.setState({
          settings: currentSettings || this.defaultSettings,
          datas: currentDatas !== oldDatas ? currentDatas : [],
          url: currentDatas['url_' + this.props.currentLang] || currentDatas.url || '',
          showAppearance: false,
        });

        let availableSettings;

        if (this.props.elementOptions[elementToEdit.type] && this.props.elementOptions[elementToEdit.type].settings)
          availableSettings = this.props.elementOptions[elementToEdit.type].settings;
        if (Object.keys(availableSettings || {}).length > 7) {
          this.setState({ currentTab: 2 });
        } else {
          this.setState({ currentTab: 1 });
        }

        if (availableSettings && availableSettings.globalSettings) {
          for (const setting of availableSettings.globalSettings) this._getGlobalSetting(setting);
        }
      }
    }
  }

  _getGlobalSetting = (key) => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'getSetting',
        key: key,
      },
    })
      .then((result) => {
        this.setState({
          ...this.state,
          globalSettings: {
            ...this.state.globalSettings,
            [key]: result.data,
          },
        });
      })
      .catch((error) => {
        GKEvent.notification('error', l('Error.'));
      });
  };

  _setGlobalSetting = (message, cb = () => {}) => {
    var success = 0;

    if (
      this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE === '1' ||
      this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE
    ) {
      if (
        this.state.globalSettings.GK_TWILIO_ACCOUNT_SID === '' ||
        this.state.globalSettings.GK_TWILIO_AUTH_TOKEN === '' ||
        !isValidMobile(this.state.globalSettings.GK_TWILIO_PHONE_NUMBER)
      ) {
        GKEvent.notification('warning', 'Please Provide valid Twilio SID, Token and Phone number.');
        return;
      }
    }

    for (const key in this.state.globalSettings) {
      if (Object.hasOwnProperty.call(this.state.globalSettings, key)) {
        const value = this.state.globalSettings[key];

        axios({
          method: 'post',
          url: ajaxUri,
          data: {
            request: 'setSetting',
            key: key,
            value: value,
          },
        })
          .then((result) => {
            success = success + 1;

            if (success == Object.keys(this.state.globalSettings).length) {
              if (message) GKEvent.notification('success', message);

              cb();
            }
          })
          .catch((error) => {
            GKEvent.notification('error', l('Error.'));
          });
      }
    }
  };

  _setShowGlobalList = (value, cb = () => {}) => {
    axios
      .post(ajaxUri, {
        request: 'setSetting',
        key: 'PS_CATEGORY_GLOBAL_SETTING',
        value: value ? 1 : 0,
      })
      .then((result) => {
        this.props.setShowGlobalList(value);
        cb();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  _changedGlobalSettings = (key, value, cb = () => {}) => {
    this.setState(
      {
        ...this.state,
        globalSettings: {
          ...this.state.globalSettings,
          [key]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _dropDown = (current) => {
    if (this.state.currentDrop === current) this.setState({ currentDrop: 0 });
    else this.setState({ currentDrop: current });
  };

  _changedDatasOne = (index, value = 0, cb = () => {}) => {
    this.setState(
      {
        ...this.state,
        datas: {
          ...this.state.datas,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _changedDatasTwo = (indexOne, indexTwo, value = 0, cb = () => {}) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = { ...this.state.datas[indexOne], ...newvalue };
    } else {
      objectValue = {
        ...this.state.datas[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedDatasOne(indexOne, objectValue, () => {
      cb();
    });
  };

  _changedSettingsOne = (index, value, cb = () => {}) => {
    this.setState(
      {
        ...this.state,
        settings: {
          ...this.state.settings,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _changedSettingsTwo = (indexOne, indexTwo, value = 0, cb = () => {}) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = { ...this.state.settings[indexOne], ...newvalue };
    } else {
      objectValue = {
        ...this.state.settings[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedSettingsOne(indexOne, objectValue, () => {
      cb();
    });
  };

  /* Slides Settings - Start */
  _editSlide = (itemId) => {
    this.state.datas.slider.forEach((slide) => {
      if (itemId.toString() === slide.id) this.setState({ slideDialog: slide });
    });
  };

  _removeItem = (itemId, type) => {
    const newItems = [];
    this.state.datas[type].forEach((element) => {
      if (itemId.toString() !== element.id) newItems.push(element);
    });

    this._changedDatasOne(type, newItems);
  };

  _changedSliderSettings = (index, value, cb = () => {}) => {
    this._changedDatasTwo('sliderSettings', index, value, () => {
      cb();
    });
  };

  _changedSliderStyle = (index, value, cb = () => {}) => {
    this._changedSettingsTwo('sliderSettings', index, value, () => {
      cb();
    });
  };

  _changedSliderStyleTwo = (indexOne, indexTwo, value) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = {
        ...(this.state.datas.sliderSettings && this.state.datas.sliderSettings[indexOne]),
        ...(this.state.settings.sliderSettings && this.state.settings.sliderSettings[indexOne]),
        ...newvalue,
      };
    } else {
      objectValue = {
        ...(this.state.datas.sliderSettings && this.state.datas.sliderSettings[indexOne]),
        ...(this.state.settings.sliderSettings && this.state.settings.sliderSettings[indexOne]),
        [indexTwo]: value,
      };
    }
    this._changedSettingsTwo('sliderSettings', indexOne, objectValue, () => {});
  };

  _changedSliderSettingsTwo = (indexOne, indexTwo, value) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = {
        ...this.state.datas.sliderSettings[indexOne],
        ...newvalue,
      };
    } else {
      objectValue = {
        ...this.state.datas.sliderSettings[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedSliderSettings(indexOne, objectValue);
  };
  /* Slides Settings - End */

  _saveItem = (datas, type, cb = () => {}) => {
    const newItems = [];
    this.state.datas[type].forEach((slide) => {
      if (datas.id.toString() !== slide.id) newItems.push(slide);
      else newItems.push(datas);
    });
    this._changedDatasOne(type, newItems, () => {
      cb();
    });
  };

  _newStyle = () => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'createStyle',
        style: this.state.settings,
      },
    })
      .then((result) => {
        if (result.data.status === 'success') this._getStyles();

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification('error', l('Error while creating the new style. Please try again.'));
      });
  };

  _removeStyle = (id) => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'removeStyle',
        id: id,
      },
    })
      .then((result) => {
        if (result.data.status === 'success') this._getStyles();

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification('error', l('Error while deleting the new style. Please try again.'));
      });
  };

  _useStyle = (style) => {
    this.setState(
      {
        settings: style,
      },
      () => {
        GKEvent.notification('success', l('Style loaded successfully'));
      }
    );
  };

  _getStyles = () => {
    axios({
      method: 'post',
      url: ajaxUri,
      data: {
        request: 'loadStyles',
      },
    })
      .then((result) => {
        this.setState({ styles: result.data, current_style: null });
      })
      .catch((error) => {
        GKEvent.notification('error', l('Error while loading existing styles. Please try again.'));
      });
  };
  // settings spacing marginTop
  _setSelectedField = (type, target, field, defaultValue = 0) => {
    const fields = (this.state.selectedFields && this.state.selectedFields[target]) || [];
    let finalFields = [];

    if (inArray(field, fields)) {
      fields.forEach((ifield) => {
        if (ifield !== field) finalFields.push(ifield);
      });
    } else {
      fields.push(field);
      finalFields = fields;
    }

    let finalFieldsValue = 0;
    if (finalFields.length > 0) {
      finalFieldsValue =
        (this.state[type] && this.state[type][target] && this.state[type][target][finalFields[0]]) || defaultValue || 0;

      finalFields.forEach((jfield) => {
        if (this.state[type] && this.state[type][target] && finalFieldsValue !== this.state[type][target][jfield])
          finalFieldsValue = 0;
      });
    }

    this.setState({
      ...this.state,
      selectedFields: {
        ...this.state.selectedFields,
        [target]: finalFields,
      },
      selectedFieldsValue: {
        ...this.state.selectedFieldsValue,
        [target]: finalFieldsValue,
      },
    });
  };

  _fontsFamilyOptions = () => {
    let object = [];

    this.fontList.forEach((font, index) => {
      object.push({
        label: font.name.split('+').join(' '),
        value: index.toString(),
        props: {
          style: { fontFamily: font.cssName },
        },
      });
    });

    return object;
  };

  _fontsWeightOptions = (fontId, fontFamily) => {
    let object = [
      {
        label: 'Extra Thin',
        value: 100,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 100 },
        },
      },
      {
        label: 'Thin',
        value: 200,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 200 },
        },
      },
      {
        label: 'regular',
        value: 300,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 300 },
        },
      },
      {
        label: 'Medium',
        value: 400,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 400 },
        },
      },
      {
        label: 'Semi Bold',
        value: 500,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 500 },
        },
      },
      {
        label: 'Bold',
        value: 600,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 600 },
        },
      },
    ];
    return object;
  };

  _sliderTextOptions = (sliderSettings, item) => {
    return (
      <div>
        <div className='section'>
          <Select
            value={(sliderSettings && sliderSettings[item + 'FontFamilyId']) || ''}
            onChange={(value) => {
              this._changedSliderStyle(item + 'FontFamilyId', value, () => {
                this._changedSliderStyle(item + 'FontFamily', this.fontList[value].cssName);
              });
            }}
            placeholder={l('Google font')}
            options={this._fontsFamilyOptions()}
            dark
          />
        </div>

        <div className='section'>
          <label className='small'>{l('Size')}</label>
          <SliderRange
            value={(sliderSettings && sliderSettings[item + 'FontSize']) || 16}
            min={10}
            max={100}
            onChange={(value) => {
              this._changedSliderStyle(item + 'FontSize', value);
            }}
          />
        </div>

        <div className='section'>
          <div className='gk-form-row-container'>
            <Select
              value={(sliderSettings && sliderSettings[item + 'FontWeight']) || ''}
              onChange={(value) => {
                this._changedSliderStyle(item + 'FontWeight', value);
              }}
              placeholder={l('Font weight')}
              options={this._fontsWeightOptions(
                (sliderSettings && sliderSettings[item + 'FontFamilyId']) || '',
                (sliderSettings && sliderSettings[item + 'FontFamily']) || ''
              )}
              dark
            />
            <ColorSetter
              color={(sliderSettings && sliderSettings[item + 'Color']) || '#000000'}
              onChangeComplete={(color) => {
                this._changedSliderStyle(item + 'Color', color);
              }}
              right
            />
          </div>
        </div>

        <div className='section'>
          <ul className='inline-options dark grow'>
            <li
              className={sliderSettings && sliderSettings[item + 'TextAlign'] === 'left' ? 'selected' : ''}
              onClick={() => {
                this._changedSliderStyle(item + 'TextAlign', 'left');
              }}
            >
              <FontAwesomeIcon icon={['fa', 'align-left']} />
            </li>
            <li
              className={sliderSettings && sliderSettings[item + 'TextAlign'] === 'center' ? 'selected' : ''}
              onClick={() => {
                this._changedSliderStyle(item + 'TextAlign', 'center');
              }}
            >
              <FontAwesomeIcon icon={['fa', 'align-center']} />
            </li>
            <li
              className={sliderSettings && sliderSettings[item + 'TextAlign'] === 'right' ? 'selected' : ''}
              onClick={() => {
                this._changedSliderStyle(item + 'TextAlign', 'right');
              }}
            >
              <FontAwesomeIcon icon={['fa', 'align-right']} />
            </li>
            <li
              className={sliderSettings && sliderSettings[item + 'TextAlign'] === 'justify' ? 'selected' : ''}
              onClick={() => {
                this._changedSliderStyle(item + 'TextAlign', 'justfy');
              }}
            >
              <FontAwesomeIcon icon={['fa', 'align-justify']} />
            </li>
          </ul>
        </div>

        <div className='section'>
          <Select
            value={sliderSettings && sliderSettings[item + 'LetterSpacing']}
            onChange={(value) => {
              this._changedSliderStyle(item + 'LetterSpacing', value);
            }}
            placeholder={l('Letter spacing')}
            options={[
              {
                label: l('Tight'),
                value: -1,
              },
              {
                label: l('Normal'),
                value: '0',
              },
              {
                label: l('Wide'),
                value: 1,
              },
            ]}
            dark
          />
        </div>

        <div className='section'>
          <div className='spacing-area'>
            <div className='top'>
              <div>
                <input
                  type='text'
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      'datas',
                      'sliderSettings',
                      item + '_marginTop',
                      (sliderSettings && sliderSettings[item + '_marginTop']) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                    inArray(item + '_marginTop', this.state.selectedFields.sliderSettings)
                      ? 'active'
                      : ''
                  }
                  value={(sliderSettings && sliderSettings[item + '_marginTop']) || 0}
                />
              </div>
            </div>
            <div className='middle'>
              <div>
                <input
                  type='text'
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      'datas',
                      'sliderSettings',
                      item + '_marginLeft',
                      (sliderSettings && sliderSettings[item + '_marginLeft']) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                    inArray(item + '_marginLeft', this.state.selectedFields.sliderSettings)
                      ? 'active'
                      : ''
                  }
                  value={(sliderSettings && sliderSettings[item + '_marginLeft']) || 0}
                />
              </div>
              <div>
                <div>
                  <span className='padding'>{l('Padding')}</span>
                  <input
                    type='text'
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        'datas',
                        'sliderSettings',
                        item + '_paddingLeft',
                        (sliderSettings && sliderSettings[item + '_paddingLeft']) || 0
                      );
                    }}
                    className={
                      this.state.selectedFields.sliderSettings &&
                      inArray(item + '_paddingLeft', this.state.selectedFields.sliderSettings)
                        ? 'active'
                        : ''
                    }
                    value={(sliderSettings && sliderSettings[item + '_paddingLeft']) || 0}
                  />
                </div>
                <div>
                  <div>
                    <input
                      type='text'
                      readOnly
                      onClick={() => {
                        this._setSelectedField(
                          'datas',
                          'sliderSettings',
                          item + '_paddingTop',
                          (sliderSettings && sliderSettings[item + '_paddingTop']) || 0
                        );
                      }}
                      className={
                        this.state.selectedFields.sliderSettings &&
                        inArray(item + '_paddingTop', this.state.selectedFields.sliderSettings)
                          ? 'active'
                          : ''
                      }
                      value={(sliderSettings && sliderSettings[item + '_paddingTop']) || 0}
                    />
                  </div>
                  <div></div>
                  <div>
                    <input
                      type='text'
                      readOnly
                      onClick={() => {
                        this._setSelectedField(
                          'datas',
                          'sliderSettings',
                          item + '_paddingBottom',
                          (sliderSettings && sliderSettings[item + '_paddingBottom']) || 0
                        );
                      }}
                      className={
                        this.state.selectedFields.sliderSettings &&
                        inArray(item + '_paddingBottom', this.state.selectedFields.sliderSettings)
                          ? 'active'
                          : ''
                      }
                      value={(sliderSettings && sliderSettings[item + '_paddingBottom']) || 0}
                    />
                  </div>
                </div>
                <div>
                  <input
                    type='text'
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        'datas',
                        'sliderSettings',
                        item + '_paddingRight',
                        (sliderSettings && sliderSettings[item + '_paddingRight']) || 0
                      );
                    }}
                    className={
                      this.state.selectedFields.sliderSettings &&
                      inArray(item + '_paddingRight', this.state.selectedFields.sliderSettings)
                        ? 'active'
                        : ''
                    }
                    value={(sliderSettings && sliderSettings[item + '_paddingRight']) || 0}
                  />
                </div>
              </div>
              <div>
                <input
                  type='text'
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      'datas',
                      'sliderSettings',
                      item + '_marginRight',
                      (sliderSettings && sliderSettings[item + '_marginRight']) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                    inArray(item + '_marginRight', this.state.selectedFields.sliderSettings)
                      ? 'active'
                      : ''
                  }
                  value={(sliderSettings && sliderSettings[item + '_marginRight']) || 0}
                />
              </div>
            </div>
            <div className='bottom'>
              <div>
                <span className='margin'>{l('Margin')}</span>
                <input
                  type='text'
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      'datas',
                      'sliderSettings',
                      item + '_marginBottom',
                      (sliderSettings && sliderSettings[item + '_marginBottom']) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.sliderSettings &&
                    inArray(item + '_marginBottom', this.state.selectedFields.sliderSettings)
                      ? 'active'
                      : ''
                  }
                  value={(sliderSettings && sliderSettings[item + '_marginBottom']) || 0}
                />
              </div>
            </div>
            <div className='gk-ray a'></div>
            <div className='gk-ray b'></div>
          </div>

          {this.state.selectedFields.sliderSettings && this.state.selectedFields.sliderSettings.length > 0 && (
            <SliderRange
              value={this.state.selectedFieldsValue.sliderSettings || 0}
              min={0}
              max={64}
              onChange={(value) => {
                this._changedSliderSettings(this.state.selectedFields.sliderSettings, value);
              }}
            />
          )}
        </div>
      </div>
    );
  };

  _editTab = (tabId) => {
    console.log(tabId);

    this.state.datas.tabs.forEach((tab) => {
      if (tab.id === tabId) this.setState({ tabDialog: tab });
    });
  };

  render() {
    const { open = false } = this.props;
    const { elementToEdit: element } = this.props;
    const { settings, datas } = this.state;

    const { sliderSettings: settingsSliderSettings } = settings || {}; // CSS Settings

    const { slider, sliderSettings: datasSliderSettings } = datas || {
      slider: [],
      sliderSettings: null,
    }; // Slider Settings

    const sliderSettings = {
      ...datasSliderSettings,
      ...settingsSliderSettings,
    };
    const { categoriesList, displayModeCats, catsPerRowLg, catsPerRowMd, catsPerRowSm, catsPerRowXs } = datas || [
      [],
      null,
      null,
    ]; // Categories List Settings
    const { productsList, productsPerRowLg, productsPerRowMd, productsPerRowSm, productsPerRowXs } = datas || [
      [],
      null,
      null,
    ]; // Product List Settings
    const { videoWidth, videoHeight } = datas || [null, null, null]; // Video Settings
    const videoUrl = datas['videoUrl_' + this.props.currentLang] || datas.videoUrl || ''; // Video Settings

    const { showThumbnails, thumbnailsPosition } = datas || [true, 'bottom']; // Products Images Settings
    let { titleTag = 'h1' } = datas || { titleTag: 'h1' }; // Products Title Settings

    const { productPricingSettings } = datas || {
      productPricingSettings: null,
    }; // Product Price Settings

    const labelCountDown = datas['labelCountDown_' + this.props.currentLang] || datas.labelCountDown || ''; // Products Stock Countdown Settings
    const { timerCountDown, activeColor, barColor, counterColor } = datas || {
      timerCountDown: 60,
      activeColor: '#FFF',
      barColor: '#FFF',
      counterColor: '#FFF',
    }; // Products Stock Countdown Settings

    const {
      timerTarget,
      timerDisplay,

      timerShape,
      timerSize,
      timerHour,
      timerMinute,
      timerSecond,
    } = datas || {}; // Products Countdown Timer Settings
    let { timerBgColor, timerColor } = datas || {}; // Products Countdown Timer Settings

    if (settings?.timerBgColor) {
      timerBgColor = settings?.timerBgColor;
    }
    if (settings?.timerColor) {
      timerColor = settings?.timerColor;
    }

    const { buttonAnimation, buttonFullWidth, customField } = datas || {
      buttonAnimation: null,
    }; // Products Add to Cart Settings

    const ATCbuttonLabel = datas['ATCbuttonLabel_' + this.props.currentLang] || datas['ATCbuttonLabel'] || '';

    const { ICbuttonBgColor, ICbuttonColor } = datas || {
      ICtitle: 'Instant Checkout',
      ICbuttonLabel: 'Add to Cart',
    }; // Instant checkout Add to Cart Settings
    const ICbuttonLabel = datas['ICbuttonLabel_' + this.props.currentLang] || datas.ICbuttonLabel || ''; // Products Stock Countdown Settings

    const QtyLabel = datas['QtyLabel_' + this.props.currentLang] || datas.QtyLabel || ''; // Products Quantity Settings

    const viewersLabel = datas['viewersLabel_' + this.props.currentLang] || datas['viewersLabel'] || ''; // Products viewers Settings

    const { viewersNumber, viewersTextColor, viewersBgColor } = datas || {
      viewersNumber: [0, 2000],
    }; // Products viewers Settings

    let { priceColor: pc, oldPriceColor: opc, pricePosition, priceSize } = datas || {}; // Product list price settings

    const { priceStyles } = settings;
    if (priceStyles?.priceColor) {
      pc = priceStyles?.priceColor;
    }
    if (priceStyles?.oldPriceColor) {
      opc = priceStyles?.oldPriceColor;
    }
    if (priceStyles?.pricePosition) {
      pricePosition = priceStyles?.pricePosition;
    }
    if (priceStyles?.priceSize) {
      priceSize = priceStyles?.priceSize;
    }

    const {
      allowReview,
      allowVote,
      reviewTextColor,
      reviewBgColor,
      reviewStarsColor,
      custom_color,
      reviewsCount,
      btnBgColor,
      btnTxtColor,
    } = datas || {
      allowReview: false,
      allowVote: false,
      reviewTextColor: null,
      reviewBgColor: null,
      reviewStarsColor: null,
      reviewsCount: null,
    }; // Products reviews Settings

    const {
      showProductPrices,
      productPriceBgColor,
      productPriceColor,
      showReductionLabel,
      reductionLabelBgColor,
      reductionLabelColor,
      showAddToCart,
      addToCartBgColor,
      addToCartColor,
    } = datas || {
      showProductPrices: null,
      productPriceBgColor: null,
      productPriceColor: null,
      showReductionLabel: null,
      reductionLabelBgColor: null,
      reductionLabelColor: null,
      showAddToCart: null,
      addToCartBgColor: null,
      addToCartColor: null,
    };

    const reductionLabel = datas['reductionLabel_' + this.props.currentLang] || datas['reductionLabel'] || '';
    const addToCartLabel01 = datas['addToCartLabel01_' + this.props.currentLang] || datas['addToCartLabel01'] || '';
    const addToCartLabel02 = datas['addToCartLabel02_' + this.props.currentLang] || datas['addToCartLabel02'] || '';

    const {
      showProductPicture,
      showProductAttribute,
      showRemoveProductButton,
      showChangeQtyAbility,
      showOldPrice,
      showCartExpiringTimer,
      tableHeadColor,
      tableHeadBgColor,
      tableBodyBgColor,
      productNameColor,
      productAttributesColor,
      oldPriceColor,
      reducedPriceColor,
      removeButtonTextColor,
      removeButtonBackgroundColor,
      tableFootColor,
      tableFootBgColor,
      cartExpiringTimerColor,
      priceTotalColor,
    } = datas || {}; // Shoppingcart Summary Settings

    const { sizeMode, displayMode, imageWidth, imageHeight } = datas || {}; // Category Image Settings

    const { relProductsPerRowLg, relProductsPerRowMd, relProductsPerRowSm, relProductsPerRowXs } = datas || {}; // Category Products Settings

    const imageUrl = datas['imageUrl_' + this.props.currentLang] || datas.imageUrl || ''; // Image Settings
    const {
      isTextOverlay = false,
      textOverlay = '',
      textOverlayColor = '',
      altAttribute = '',
    } = datas || {
      isTextOverlay: false,
      textOverlay: '',
      textOverlay: '',
      altAttribute: '',
    }; // image settings

    const linkLabel = datas['linkLabel_' + this.props.currentLang] || '';
    const url = datas['url_' + this.props.currentLang] || datas.url || '';

    const { linkTarget, linkType, iconClass, useIcon, iconPosition, iconSpacing = 6 } = datas || {}; // Link Settings

    const { listItems, showInline } = datas || {}; // List Settings

    const { newsletterSettings: datasnewsletterSettings } = datas || {
      newsletterSettings: null,
    }; // Subscribe Newsletter Settings
    const { newsletterSettings: settingsnewsletterSettings } = settings || {
      newsletterSettings: null,
    };

    const newsletterSettings = {
      ...datasnewsletterSettings,
      ...settingsnewsletterSettings,
      buttonIconPosition: datasnewsletterSettings?.buttonIconPosition,
    };

    const {
      currentDesign,
      variationsLabelColor,
      variationsBgColor,
      variationsColor,
      variationsBgColorHover,
      variationsColorHover,
    } = datas || {}; // Variations Designs Settings

    const stepsSettings = {
      ...datas,
      ...settings,
    }; // Checkout steps settings

    const { priceColor, tableBgColor, tableBorderColor } = datas || {}; // Checkout summary Settings

    const { cartPriceColor, totalCart_product, totalCart_shipping, totalCart_tax } = datas || {}; // Upsell Product Cart Price

    const { showat, atcbc, atcc } = datas || {}; // Upsell Product Cart Price

    const atclabel = datas['atclabel_' + this.props.currentLang] || datas['atclabel'] || ''; // Products viewers Settings

    const labelQD = datas['labelQD_' + this.props.currentLang] || datas.labelQD || '';

    const htmlCode = datas['htmlCode_' + this.props.currentLang] || datas.htmlCode || ''; // Html Code

    const cartPriceLabel = datas['cartPriceLabel_' + this.props.currentLang] || datas.cartPriceLabel || ''; // Html Code

    const { headingText, headingTag, collapseOpen = 0 } = datas || {}; // collapse heading options;

    const {
      tabsSettings: { activeTabColor = '', tabColor = '', tabTextColor = '', activeTabTextColor = '' } = {},
      tabs = [],
    } = datas || {}; // tabs settings

    const placeholder = <div className='placeholderContent'>{l('Drop Here...')}</div>;

    if (element) {
      let availableSettings = {};

      if (
        element.elementId &&
        this.props.elementOptions[element.elementId] &&
        this.props.elementOptions[element.elementId].settings
      ) {
        availableSettings = this.props.elementOptions[element.elementId].settings;
      } else {
        availableSettings = this.props.elementToEdit?.options?.settings || {};
      }

      const iconsList = iconList;

      let currentDesignsDropdown = [];
      if (availableSettings.designSettings) {
        for (let i = 1; i <= availableSettings.designSettings; i++) {
          currentDesignsDropdown.push({
            label: l('Design') + ' ' + i,
            value: i,
          });
        }
      }

      if (availableSettings.sliderTextSettings) {
        const { titleTag: title = availableSettings.sliderTestimonialSettings ? 'h2' : 'h3' } = datas || {
          titleTag: availableSettings.sliderTestimonialSettings ? 'h2' : 'h3',
        };

        titleTag = title;
      }

      return (
        <>
          {open && (
            <div className='float-settings'>
              <div className='body-float'>
                {availableSettings?.tabsSettings && this.state.tabDialog && (
                  <TabDialog
                    tab={this.state.tabDialog}
                    onClose={() => {
                      this.setState({ tabDialog: null });
                    }}
                    onSave={(datas) => {
                      // console.log(datas);
                      this._saveItem(datas, 'tabs', () => {
                        this.setState({ tabDialog: null });
                      });
                    }}
                    title={l('Edit Tab')}
                    currentLang={this.props.currentLang}
                  />
                )}
                {availableSettings?.sliderItems && this.state.slideDialog && (
                  <SlideDialog
                    slide={this.state.slideDialog}
                    onClose={() => {
                      this.setState({ slideDialog: null });
                    }}
                    onSave={(datas) => {
                      this._saveItem(datas, 'slider', () => {
                        this.setState({ slideDialog: null });
                      });
                    }}
                    title={l('Edit item')}
                    isTestimonial={availableSettings?.sliderTestimonialSettings}
                  />
                )}
                {availableSettings?.listSettings && this.state.listDatas && (
                  <ListDialog
                    listDatas={this.state.listDatas}
                    listItems={(this.state.datas && this.state.datas.listItems) || []}
                    iconsList={iconsList}
                    onClose={() => {
                      this.setState({ listDatas: null });
                    }}
                    onSubmit={(datas) => {
                      this._saveItem(datas, 'listItems', () => {
                        this.setState({ listDatas: null });
                      });
                    }}
                  />
                )}
                <div className='head-wraper'>
                  <div className='head'>
                    <Icon
                      icon='time'
                      onClick={() => {
                        this.props.editElement(null);
                        this.props.setSettingsOpen();
                      }}
                    />
                    <h3>{l(element.name)}</h3>
                  </div>
                </div>
                <ul className='settings-area'>
                  {availableSettings.sliderItems && (
                    <li className={'active'}>
                      <div className='head'>{l('Items')}</div>
                      <div className='body'>
                        <button
                          className='new-item'
                          onClick={() => {
                            newDraggableElement(this.state.datas.slider, 'slider', 'Slide', (elements) => {
                              this._changedDatasOne('slider', elements);
                            });
                          }}
                        >
                          <Icon icon='plus' />
                        </button>
                        <div className='section'>
                          {(slider && slider.length > 0 && (
                            <DragSortableList
                              dropBackTransitionDuration={0.3}
                              type='vertical'
                              size='normal'
                              dragType='slider'
                              items={slider}
                              placeholder={placeholder}
                              currentLang={this.props.currentLang}
                              icons={{
                                move: <Icon icon='move' />,
                                dots: <Icon icon='dots' />,
                              }}
                              onEdit={this._editSlide}
                              onRemove={(itemId) => {
                                this._removeItem(itemId, 'slider');
                              }}
                              onSort={(sortedList, dropEvent) => {
                                this._changedDatasOne('slider', sortedList);
                              }}
                            />
                          )) || (
                            <div className='gk-warning-message'>
                              <p>{l('Add your first item')}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.designSettings && (
                    <li>
                      <div className='head'>{l('Design')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Current design')}</label>

                            <Select
                              value={currentDesign || 'left'}
                              onChange={(value) => {
                                this._changedDatasOne('currentDesign', value);
                              }}
                              options={currentDesignsDropdown}
                              dark
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.productReviewColors && (
                    <li>
                      <div className='head'>{l('Colors')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Text color')}</label>
                            <ColorSetter
                              color={reviewTextColor || '#000'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('reviewTextColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Background color')}</label>
                            <ColorSetter
                              color={reviewBgColor || '#f5f5f5'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('reviewBgColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Rate color')}</label>
                            <ColorSetter
                              color={reviewStarsColor || '#FFA501'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('reviewStarsColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Secondary color')}</label>
                            <ColorSetter
                              color={custom_color || '#f042a8'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('custom_color', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        {allowReview && (
                          <>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Button Background')}</label>
                                <ColorSetter
                                  color={btnBgColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('btnBgColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Button Text')}</label>
                                <ColorSetter
                                  color={btnTxtColor || '#fff'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('btnTxtColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </li>
                  )}
                  {availableSettings.imageUpload && (
                    <li>
                      <div className='head'>{l('Upload Image') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <ImageUploader
                            withIcon={true}
                            buttonText={l('Upload image')}
                            onChange={(url) => {
                              this._changedDatasOne('imageUrl_' + this.props.currentLang, url);
                            }}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.webp']}
                            maxFileSize={5242880}
                            withPreview={true}
                            singleImage={true}
                            defaultImages={imageUrl || ''}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.inlineSettings && (
                    <li>
                      <div className='head'>{l('Inline Settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasOne('showInline', true);
                              }}
                              className={showInline ? 'selected' : ''}
                            >
                              <span>{l('Inlined')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('showInline', false);
                              }}
                              className={!showInline ? 'selected' : ''}
                            >
                              <span>{l('Not inlined')}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.sliderSettings && (
                    <li>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Auto play')}</label>
                            <Switch
                              checked={(sliderSettings && sliderSettings.autoslide) || false}
                              onChange={(e) => {
                                this._changedSliderSettings('autoslide', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        {sliderSettings && sliderSettings.autoslide && (
                          <div className='section'>
                            <label className='small'>
                              <strong>{l('Play timeout (seconds)')}</strong>
                            </label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.duration) || 5}
                              min={0}
                              max={10}
                              onChange={(value) => {
                                this._changedSliderSettings('duration', value);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </li>
                  )}

                  {availableSettings.carouselSettings && (
                    <li className={this.state.currentDrop === 8 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(8)}>
                        <Icon icon={this.state.currentDrop === 8 ? 'dropup' : 'dropdown'} />
                        {l('Items count per device')}
                      </div>
                      {this.state.currentDrop === 8 && (
                        <div className='body'>
                          <div className='section'>
                            <label className='small'>{l('Desktop')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_count_desktop) || 1}
                              min={0}
                              max={10}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_count_desktop', value);
                              }}
                            />
                          </div>
                          <div className='section'>
                            <label className='small'>{l('Tab')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_count_tab) || 1}
                              min={0}
                              max={10}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_count_tab', value);
                              }}
                            />
                          </div>
                          <div className='section'>
                            <label className='small'>{l('Mobile Phone')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_count_mobile) || 1}
                              min={0}
                              max={10}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_count_mobile', value);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.carouselSettings && (
                    <li className={this.state.currentDrop === 9 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(9)}>
                        <Icon icon={this.state.currentDrop === 9 ? 'dropup' : 'dropdown'} />
                        {l('Spacing Between Items')}
                      </div>
                      {this.state.currentDrop === 9 && (
                        <div className='body'>
                          <div className='section'>
                            <label className='small'>{l('Desktop')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_spacing_desktop) || 1}
                              min={0}
                              max={50}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_spacing_desktop', value);
                              }}
                            />
                          </div>
                          <div className='section'>
                            <label className='small'>{l('Tab')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_spacing_tab) || 1}
                              min={0}
                              max={50}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_spacing_tab', value);
                              }}
                            />
                          </div>
                          <div className='section'>
                            <label className='small'>{l('Mobile Phone')}</label>
                            <SliderRange
                              value={(sliderSettings && sliderSettings.item_spacing_mobile) || 1}
                              min={0}
                              max={50}
                              onChange={(value) => {
                                this._changedDatasTwo('sliderSettings', 'item_spacing_mobile', value);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.catListsSettings && (
                    <li className={this.state.currentDrop === 6 ? 'active' : ''}>
                      <div className='head'>{l('Display type')}</div>
                      <div className='body'>
                        <div className='section'>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasOne('displayModeCats', 'tiles');
                              }}
                              className={
                                !displayModeCats || (displayModeCats && displayModeCats === 'tiles') ? 'selected' : ''
                              }
                            >
                              <span>{l('Tiles')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('displayModeCats', 'blocks');
                              }}
                              className={displayModeCats && displayModeCats === 'blocks' ? 'selected' : ''}
                            >
                              <span>{l('Blocks')}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.catListsSettings && (
                    <li className={this.state.currentDrop === 6 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(6)}>
                        <Icon icon={this.state.currentDrop === 6 ? 'dropup' : 'dropdown'} />
                        {l('Select categories')}
                      </div>
                      {this.state.currentDrop === 6 && (
                        <div className='body'>
                          <div className='section scroller'>
                            <ListSortedItemsCheckboxes
                              list={categoriesList || []}
                              onCheck={(list) => {
                                this._changedDatasOne('categoriesList', list);
                              }}
                              items={this.props.fetchedCategories.leveled}
                              inlineItems={this.props.fetchedCategories.normal}
                              multiple
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.catListsSettings && (
                    <li className={this.state.currentDrop === 7 ? 'active' : ''}>
                      <div
                        className={`head ${(categoriesList && categoriesList.length > 0 && 'attention') || ''}`}
                        onClick={() => this._dropDown(7)}
                      >
                        <Icon icon={this.state.currentDrop === 7 ? 'dropup' : 'dropdown'} />
                        {l('Categories position')}
                      </div>
                      {this.state.currentDrop === 7 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container' style={{ marginLeft: 12, marginBottom: 10 }}>
                              <label className='small'>Show global list order</label>
                              <input
                                type={'checkbox'}
                                checked={this.props.showGlobalList}
                                onChange={(e) => {
                                  console.log(e.target.checked);
                                  this._setShowGlobalList(e.target.checked);
                                }}
                              />
                            </div>
                            {(categoriesList && categoriesList.length > 0 && (
                              <DragSortableList
                                dropBackTransitionDuration={0.3}
                                dragType='catslist'
                                size='small'
                                type='vertical'
                                currentLang={this.props.currentLang}
                                items={
                                  prettifySortItem(
                                    categoriesList,
                                    this.props.fetchedCategories.normal,
                                    'name',
                                    l('Category')
                                  ) || []
                                }
                                placeholder={placeholder}
                                icons={{
                                  move: <Icon icon='move' />,
                                  dots: <Icon icon='dots' />,
                                }}
                                onSort={(sortedList, dropEvent) => {
                                  let newCategoriesList = [];

                                  sortedList.forEach((item) => {
                                    newCategoriesList.push(item.id);
                                  });

                                  this._changedDatasOne('categoriesList', newCategoriesList);
                                }}
                              />
                            )) || (
                              <div className='gk-error-message'>
                                <p>{l('Please select at least one category from above.')}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.catListsSettings && (
                    <li className={this.state.currentDrop === 68 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(68)}>
                        <Icon icon={this.state.currentDrop === 68 ? 'dropup' : 'dropdown'} />
                        {l('Categories per row')}
                      </div>
                      {this.state.currentDrop === 68 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Desktop')}</label>

                              <Select
                                value={catsPerRowLg || 3}
                                onChange={(value) => {
                                  this._changedDatasOne('catsPerRowLg', value);
                                }}
                                options={[
                                  { label: '1 category', value: 12 },
                                  { label: '2 Categories', value: 6 },
                                  { label: '3 Categories', value: 4 },
                                  { label: '4 Categories', value: 3 },
                                  { label: '6 Categories', value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Horizontal Tab')}</label>

                              <Select
                                value={catsPerRowMd || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('catsPerRowMd', value);
                                }}
                                options={[
                                  { label: l('1 category'), value: 12 },
                                  { label: l('2 Categories'), value: 6 },
                                  { label: l('3 Categories'), value: 4 },
                                  { label: l('4 Categories'), value: 3 },
                                  { label: l('6 Categories'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Vertical Tab')}</label>

                              <Select
                                value={catsPerRowSm || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('catsPerRowSm', value);
                                }}
                                options={[
                                  { label: l('1 category'), value: 12 },
                                  { label: l('2 Categories'), value: 6 },
                                  { label: l('3 Categories'), value: 4 },
                                  { label: l('4 Categories'), value: 3 },
                                  { label: l('6 Categories'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Mobile')}</label>

                              <Select
                                value={catsPerRowXs || 6}
                                onChange={(value) => {
                                  this._changedDatasOne('catsPerRowXs', value);
                                }}
                                options={[
                                  { label: l('1 category'), value: 12 },
                                  { label: l('2 Categories'), value: 6 },
                                  { label: l('3 Categories'), value: 4 },
                                  { label: l('4 Categories'), value: 3 },
                                  { label: l('6 Categories'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.videoSource && element.type !== 'product_video' && (
                    <li>
                      <div className='head'>{l('Video Source') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-custom-message'>
                            <p>
                              {l(
                                'YouTube, Facebook, Twitch, SoundCloud, Streamable, Vimeo, Wistia, Mixcloud, and DailyMotion.'
                              )}
                            </p>
                          </div>
                        </div>
                        <div className='section'>
                          <TextField
                            placeholder={'Your video url'}
                            value={videoUrl || ''}
                            onChange={(value) => {
                              this._changedDatasOne('videoUrl_' + this.props.currentLang, value);
                            }}
                            dark
                            error={!validURL(videoUrl || '') ? l('Url format not correct') : false}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.videoDimensions && (
                    <li>
                      <div className='head'>{l('Video Dimensions')}</div>
                      <div className='body'>
                        <div className='section'>
                          <label className='small'>{l('Width')}</label>
                          <SliderRange
                            value={videoWidth || 800}
                            min={50}
                            max={1600}
                            onChange={(value) => {
                              this._changedDatasOne('videoWidth', value);
                            }}
                          />
                        </div>
                        <div className='section'>
                          <label className='small'>{l('Height')}</label>
                          <SliderRange
                            value={videoHeight || 600}
                            min={50}
                            max={1600}
                            onChange={(value) => {
                              this._changedDatasOne('videoHeight', value);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productPicturesSettings && (
                    <li>
                      <div className='head'>{l('Product Images Settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Show thumbnails')}</label>

                            <Switch
                              checked={showThumbnails}
                              onChange={(e) => {
                                this._changedDatasOne('showThumbnails', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        {showThumbnails && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Position')}</label>

                              <Select
                                value={thumbnailsPosition || 'bottom'}
                                onChange={(value) => {
                                  this._changedDatasOne('thumbnailsPosition', value);
                                }}
                                options={[
                                  { label: l('Top'), value: 'top' },
                                  { label: l('Bottom'), value: 'bottom' },
                                  { label: l('Left'), value: 'left' },
                                  { label: l('Right'), value: 'right' },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  {(availableSettings.productTitleSettings || availableSettings.sliderTextSettings) && (
                    <li>
                      <div className='head'>{l('Title tag (SEO)')}</div>
                      <div className='body'>
                        <div className='section'>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h1');
                              }}
                              className={titleTag && titleTag === 'h1' ? 'selected' : ''}
                            >
                              <span>{l('H1')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h2');
                              }}
                              className={titleTag && titleTag === 'h2' ? 'selected' : ''}
                            >
                              <span>{l('H2')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h3');
                              }}
                              className={titleTag && titleTag === 'h3' ? 'selected' : ''}
                            >
                              <span>{l('H3')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h4');
                              }}
                              className={titleTag && titleTag === 'h4' ? 'selected' : ''}
                            >
                              <span>{l('H4')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h5');
                              }}
                              className={titleTag && titleTag === 'h5' ? 'selected' : ''}
                            >
                              <span>{l('H5')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('titleTag', 'h6');
                              }}
                              className={titleTag && titleTag === 'h6' ? 'selected' : ''}
                            >
                              <span>{l('H6')}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productStockCountdownSettings && (
                    <li>
                      <div className='head'>{l('Countdown title') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-custom-message'>
                            <p>
                              {l('Please add')} <strong>%%</strong>{' '}
                              {l('it will be automatically replaced by the counter')}
                            </p>
                          </div>
                        </div>
                        <div className='section'>
                          <TextField
                            value={labelCountDown || ''}
                            onChange={(value) => {
                              this._changedDatasOne('labelCountDown_' + this.props.currentLang, value);
                            }}
                            dark
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productStockCountdownSettings && (
                    <li>
                      <div className='head'>{l('Countdown timer')}</div>
                      <div className='body'>
                        <div className='section'>
                          <label className='small'>{l('Seconds')}</label>
                          <SliderRange
                            value={timerCountDown || 60}
                            min={5}
                            max={240}
                            onChange={(value) => {
                              this._changedDatasOne('timerCountDown', value);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productStockCountdownColors && (
                    <li>
                      <div className='head'>{l('Countdown colors')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Counter color')}</label>
                            <ColorSetter
                              color={counterColor || '#a94442'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('counterColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Active bar color')}</label>
                            <ColorSetter
                              color={activeColor || '#5cb85c'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('activeColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Danger bar color')}</label>
                            <ColorSetter
                              color={barColor || '#d9534f'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('barColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productCountDownTimerSettings && (
                    <li>
                      <div className='head'>{l('Settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasOne('timerTarget', '-1');
                              }}
                              className={!timerTarget || (timerTarget && timerTarget === '-1') ? 'selected' : ''}
                            >
                              <span>{l('Until Midnight')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('timerTarget', 'static');
                              }}
                              className={timerTarget && timerTarget === 'static' ? 'selected' : ''}
                            >
                              <span>{l('Static time')}</span>
                            </li>
                          </ul>
                        </div>
                        {timerTarget === 'static' && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Hours')}</label>
                              <Select
                                value={timerHour || 0}
                                onChange={(value) => {
                                  this._changedDatasOne('timerHour', value);
                                }}
                                options={optionLoop(0, 23, '', 'H')}
                                dark
                              />
                            </div>
                          </div>
                        )}
                        {timerTarget === 'static' && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Minutes')}</label>
                              <Select
                                value={timerMinute || 0}
                                onChange={(value) => {
                                  this._changedDatasOne('timerMinute', value);
                                }}
                                options={optionLoop(0, 59, '', 'M')}
                                dark
                              />
                            </div>
                          </div>
                        )}
                        {timerTarget === 'static' && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Seconds')}</label>
                              <Select
                                value={timerSecond || 0}
                                onChange={(value) => {
                                  this._changedDatasOne('timerSecond', value);
                                }}
                                options={optionLoop(0, 59, '', 'S')}
                                dark
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  {availableSettings.productCountDownTimerSettings && (
                    <li>
                      <div className='head'>{l('Display options')}</div>

                      <div className='body'>
                        <div className='section'>
                          <label className='small'>{l('Show')}</label>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasTwo(
                                  'timerDisplay',
                                  'hours',
                                  timerDisplay && timerDisplay.hours ? !timerDisplay.hours : true
                                );
                              }}
                              className={timerDisplay && timerDisplay.hours ? 'selected' : ''}
                            >
                              <span>{l('Hours')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasTwo(
                                  'timerDisplay',
                                  'minutes',
                                  timerDisplay && timerDisplay.minutes ? !timerDisplay.minutes : true
                                );
                              }}
                              className={timerDisplay && timerDisplay.minutes ? 'selected' : ''}
                            >
                              <span>{l('Minutes')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasTwo(
                                  'timerDisplay',
                                  'seconds',
                                  timerDisplay && timerDisplay.seconds ? !timerDisplay.seconds : true
                                );
                              }}
                              className={timerDisplay && timerDisplay.seconds ? 'selected' : ''}
                            >
                              <span>{l('Seconds')}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productCountDownTimerSettings && (
                    <li>
                      <div className='head'>{l('Styling')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Size')}</label>
                            <Select
                              value={timerSize || 'medium'}
                              onChange={(value) => {
                                this._changedDatasOne('timerSize', value);
                              }}
                              options={[
                                {
                                  label: l('Extra Small'),
                                  value: 'extra-small',
                                },
                                {
                                  label: l('Small'),
                                  value: 'smaller',
                                },
                                {
                                  label: l('Medium'),
                                  value: 'medium',
                                },
                                {
                                  label: l('Large'),
                                  value: 'large',
                                },
                                {
                                  label: l('Larger'),
                                  value: 'larger',
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Format')}</label>
                            <Select
                              value={timerShape || 'square'}
                              onChange={(value) => {
                                this._changedDatasOne('timerShape', value);
                              }}
                              options={[
                                {
                                  label: l('Square'),
                                  value: 'square',
                                },
                                {
                                  label: l('Circle'),
                                  value: 'circle',
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productATCSettings && (
                    <li>
                      <div className='head'>{l('Button content') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Add to Cart')}
                            value={ATCbuttonLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('ATCbuttonLabel_' + this.props.currentLang, value);
                            }}
                            dark
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productInstantCheckoutSettings && (
                    <li>
                      <div className='head'>{l('Add to cart label')}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Add to Cart')}
                            value={ICbuttonLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('ICbuttonLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productInstantCheckoutSettings && (
                    <li className={this.state.currentDrop === 29 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(29)}>
                        <FontAwesomeIcon
                          icon={['fal', this.state.currentDrop === 29 ? 'chevron-up' : 'chevron-down']}
                        />
                        {l('Add to cart design')}
                      </div>
                      {this.state.currentDrop === 29 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Background color')}</label>
                              <ColorSetter
                                color={ICbuttonBgColor || '#333333'}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('ICbuttonBgColor', color);
                                }}
                                width='100%'
                                right
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Color')}</label>
                              <ColorSetter
                                color={ICbuttonColor || '#f5f5f5'}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('ICbuttonColor', color);
                                }}
                                width='100%'
                                right
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.productQuantitySettings && (
                    <li>
                      <div className='head'>{l('Quantity label') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Quantity')}
                            value={QtyLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('QtyLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productsList && (
                    <>
                      <li>
                        <div className='head'>{l('Title tag (SEO)')}</div>
                        <div className='body'>
                          <div className='section'>
                            <ul className='inline-options dark grow'>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h1');
                                }}
                                className={titleTag && titleTag === 'h1' ? 'selected' : ''}
                              >
                                <span>{l('H1')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h2');
                                }}
                                className={titleTag && titleTag === 'h2' ? 'selected' : ''}
                              >
                                <span>{l('H2')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h3');
                                }}
                                className={titleTag && titleTag === 'h3' ? 'selected' : ''}
                              >
                                <span>{l('H3')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h4');
                                }}
                                className={titleTag && titleTag === 'h4' ? 'selected' : ''}
                              >
                                <span>{l('H4')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h5');
                                }}
                                className={titleTag && titleTag === 'h5' ? 'selected' : ''}
                              >
                                <span>{l('H5')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('titleTag', 'h6');
                                }}
                                className={titleTag && titleTag === 'h6' ? 'selected' : ''}
                              >
                                <span>{l('H6')}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li className={this.state.currentDrop === 7 ? 'active' : ''}>
                        <div className='head' onClick={() => this._dropDown(7)}>
                          <Icon icon={this.state.currentDrop === 7 ? 'dropup' : 'dropdown'} />
                          {l('Select products')}
                        </div>
                        {this.state.currentDrop === 7 && (
                          <div className='body'>
                            <ProductFilter
                              list={productsList || []}
                              multiple
                              onCheck={(list) => {
                                this._changedDatasOne('productsList', list);
                              }}
                            />
                          </div>
                        )}
                      </li>
                    </>
                  )}
                  {availableSettings.productsList && (
                    <li className={this.state.currentDrop === 9 ? 'active' : ''}>
                      <div
                        className={`head ${(productsList && productsList.length > 0 && 'attention') || ''}`}
                        onClick={() => this._dropDown(9)}
                      >
                        <Icon icon={this.state.currentDrop === 9 ? 'dropup' : 'dropdown'} />
                        {l('Products positions')}
                      </div>
                      {this.state.currentDrop === 9 && (
                        <div className='body'>
                          {(productsList && productsList.length > 0 && (
                            <div className='section'>
                              <DragSortableList
                                dropBackTransitionDuration={0.3}
                                type='vertical'
                                size='small'
                                currentLang={this.props.currentLang}
                                items={
                                  prettifySortItem(productsList, this.props.fetchedProducts, 'name', 'Product') || []
                                }
                                placeholder={placeholder}
                                onSort={(sortedList, dropEvent) => {
                                  let newProductsList = [];

                                  sortedList.forEach((item) => {
                                    newProductsList.push(item.id);
                                  });

                                  this._changedDatasOne('productsList', newProductsList);
                                }}
                                icons={{
                                  move: <Icon icon='move' />,
                                  dots: <Icon icon='dots' />,
                                }}
                              />
                            </div>
                          )) || (
                            <div className='gk-error-message'>
                              <p>{l('Please select at least one product from above.')}</p>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.productsList && (
                    <li className={this.state.currentDrop === 67 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(67)}>
                        <Icon icon={this.state.currentDrop === 67 ? 'dropup' : 'dropdown'} />
                        {l('Products per row')}
                      </div>
                      {this.state.currentDrop === 67 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Desktop')}</label>

                              <Select
                                value={productsPerRowLg || 3}
                                onChange={(value) => {
                                  this._changedDatasOne('productsPerRowLg', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Horizontal')} Tab</label>

                              <Select
                                value={productsPerRowMd || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('productsPerRowMd', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Vertical')} Tab</label>

                              <Select
                                value={productsPerRowSm || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('productsPerRowSm', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Mobile')}</label>

                              <Select
                                value={productsPerRowXs || 6}
                                onChange={(value) => {
                                  this._changedDatasOne('productsPerRowXs', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}

                  {availableSettings.atcStyling && (
                    <li className={this.state.currentDrop === 77 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(77)}>
                        <Icon icon={this.state.currentDrop === 77 ? 'dropup' : 'dropdown'} />
                        {l('Add to cart settings')}
                      </div>
                      {this.state.currentDrop === 77 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Show button')}</label>

                              <Switch
                                checked={showat}
                                onChange={(e) => {
                                  this._changedDatasOne('showat', e.target.checked);
                                }}
                              />
                            </div>
                          </div>
                          {showat && (
                            <div className='section'>
                              <TextField
                                placeholder={l('Label')}
                                value={atclabel || ''}
                                onChange={(value) => {
                                  this._changedDatasOne('atclabel_' + this.props.currentLang, value);
                                }}
                                dark
                                required
                              />
                            </div>
                          )}
                          {showat && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Background color')}</label>
                                <ColorSetter
                                  color={atcbc}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('atcbc', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showat && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Color')}</label>
                                <ColorSetter
                                  color={atcc}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('atcc', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.productViewersSettings && (
                    <li>
                      <div className='head'>{l('Number of viewers')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-custom-message'>
                            <p>
                              {l(
                                'Number of viewers will be generated randomly respecting the range that you define below.'
                              )}
                            </p>
                          </div>
                          <SliderRange
                            value={viewersNumber || [0, 2400]}
                            min={1}
                            max={2400}
                            onChange={(value) => {
                              this._changedDatasOne('viewersNumber', value);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productViewersSettings && (
                    <li>
                      <div className='head'>{l('Label') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Label')}
                            value={viewersLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('viewersLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productViewersSettings && (
                    <li>
                      <div className='head'>{l('Number box styling')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Text color')}</label>
                            <ColorSetter
                              color={viewersTextColor || '#FFFFFF'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('viewersTextColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>

                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Background color')}</label>
                            <ColorSetter
                              color={viewersBgColor || '#008000'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('viewersBgColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.productReviewSettings && (
                    <li>
                      <div className='head'>{l('Settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Allow submit review')}</label>

                            <Switch
                              checked={allowReview}
                              onChange={(e) => {
                                this._changedDatasOne('allowReview', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Allow review vote')}</label>

                            <Switch
                              checked={allowVote}
                              onChange={(e) => {
                                this._changedDatasOne('allowVote', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <label className='small'>{l('Number of reviews to show')}</label>

                          <SliderRange
                            value={reviewsCount || 5}
                            min={1}
                            max={50}
                            onChange={(value) => {
                              this._changedDatasOne('reviewsCount', value);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.productBundlePrices && (
                    <li className={this.state.currentDrop === 24 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(24)}>
                        <Icon icon={this.state.currentDrop === 24 ? 'dropup' : 'dropdown'} />
                        {l('Products prices')}
                      </div>
                      {this.state.currentDrop === 24 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Show product price')}</label>

                              <Switch
                                checked={showProductPrices}
                                onChange={(e) => {
                                  this._changedDatasOne('showProductPrices', e.target.checked);
                                }}
                              />
                            </div>
                          </div>
                          {showProductPrices && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Text color')}</label>
                                <ColorSetter
                                  color={productPriceColor || '#FFF'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('productPriceColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showProductPrices && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Background color')}</label>
                                <ColorSetter
                                  color={productPriceBgColor || '#FFF'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('productPriceBgColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.productBundleReductionAlert && (
                    <li className={this.state.currentDrop === 25 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(25)}>
                        <Icon icon={this.state.currentDrop === 25 ? 'dropup' : 'dropdown'} />
                        {l('Reduction alert')}
                      </div>
                      {this.state.currentDrop === 25 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Show reduction label')}</label>
                              <Switch
                                checked={showReductionLabel}
                                onChange={(e) => {
                                  this._changedDatasOne('showReductionLabel', e.target.checked);
                                }}
                              />
                            </div>
                          </div>
                          {showReductionLabel && (
                            <div className='section'>
                              <label className='small'>{l('Reduction label')}</label>
                              <div className='gk-custom-message'>
                                <p className='text-left'>%REDUCTION_PERCENT% : {l('Reduction percent.')}</p>
                                <p className='text-left'>%REDUCTION_PRICE% : {l('Reduction price.')}</p>
                                <p className='text-left'>%REDUCED_PRICE% : {l('Reduced price.')}</p>
                              </div>
                              <TextField
                                label={l('Reduction label') + ' (' + getLangLabel() + ')'}
                                placeholder={l('Save')}
                                value={reductionLabel || ''}
                                onChange={(value) => {
                                  this._changedDatasOne('reductionLabel_' + this.props.currentLang, value);
                                }}
                                dark
                                required
                                solid
                                size='small'
                              />
                            </div>
                          )}
                          {showReductionLabel && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Text color')}</label>
                                <ColorSetter
                                  color={reductionLabelColor || '#FFF'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('reductionLabelColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showReductionLabel && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Background color')}</label>
                                <ColorSetter
                                  color={reductionLabelBgColor || '#000'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('reductionLabelBgColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.productBundleATC && (
                    <li className={this.state.currentDrop === 26 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(26)}>
                        <Icon icon={this.state.currentDrop === 26 ? 'dropup' : 'dropdown'} />
                        {l('Add to cart')}
                      </div>
                      {this.state.currentDrop === 26 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Show add to cart button')}</label>

                              <Switch
                                checked={showAddToCart}
                                onChange={(e) => {
                                  this._changedDatasOne('showAddToCart', e.target.checked);
                                }}
                              />
                            </div>
                          </div>
                          {showAddToCart && (
                            <div className='section'>
                              <label className='small'>{l('Reduction label')}</label>
                              <div className='gk-custom-message'>
                                <p className='text-left'>%REDUCTION_PERCENT% : {l('Reduction percent.')}</p>
                                <p className='text-left'>%REDUCTION_PRICE% : {l('Reduction price.')}</p>
                                <p className='text-left'>%REDUCED_PRICE% : {l('Reduced price.')}</p>
                              </div>
                              <TextField
                                label={l('First label') + ' (' + getLangLabel() + ')'}
                                placeholder={l('Get Now')}
                                value={addToCartLabel01 || ''}
                                onChange={(value) => {
                                  this._changedDatasOne('addToCartLabel01_' + this.props.currentLang, value);
                                }}
                                dark
                                required
                                solid
                                size='small'
                              />
                              <TextField
                                label={l('Second label') + ' (' + getLangLabel() + ')'}
                                placeholder={l('This Offer')}
                                value={addToCartLabel02 || ''}
                                onChange={(value) => {
                                  this._changedDatasOne('addToCartLabel02_' + this.props.currentLang, value);
                                }}
                                dark
                                required
                                solid
                                size='small'
                              />
                            </div>
                          )}
                          {showAddToCart && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Text color')}</label>
                                <ColorSetter
                                  color={addToCartColor || '#FFF'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('addToCartColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showAddToCart && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Background color')}</label>
                                <ColorSetter
                                  color={addToCartBgColor || '#000'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('addToCartBgColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.summaryDisplaySettings && (
                    <li>
                      <div className='head'>Settings</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Product picture')}</label>
                            <Switch
                              checked={showProductPicture}
                              onChange={(e) => {
                                this._changedDatasOne('showProductPicture', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Product attributes')}</label>
                            <Switch
                              checked={showProductAttribute}
                              onChange={(e) => {
                                this._changedDatasOne('showProductAttribute', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Remove product button')}</label>
                            <Switch
                              checked={showRemoveProductButton}
                              onChange={(e) => {
                                this._changedDatasOne('showRemoveProductButton', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Change qty')}</label>
                            <Switch
                              checked={showChangeQtyAbility}
                              onChange={(e) => {
                                this._changedDatasOne('showChangeQtyAbility', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Cart expiring timer')}</label>
                            <Switch
                              checked={showCartExpiringTimer}
                              onChange={(e) => {
                                this._changedDatasOne('showCartExpiringTimer', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.summaryStyling && (
                    <li className={this.state.currentDrop === 28 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(28)}>
                        <Icon icon={this.state.currentDrop === 28 ? 'dropup' : 'dropdown'} />
                        {l('Head colors')}
                      </div>
                      {this.state.currentDrop === 28 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Text color')}</label>
                              <ColorSetter
                                color={tableHeadColor || '#000'}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('tableHeadColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Background color')}</label>
                              <ColorSetter
                                color={tableHeadBgColor || '#000'}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('tableHeadBgColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.summaryStyling && (
                    <li className={this.state.currentDrop === 29 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(29)}>
                        <Icon icon={this.state.currentDrop === 29 ? 'dropup' : 'dropdown'} />
                        {l('Body colors')}
                      </div>
                      {this.state.currentDrop === 29 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Background color')}</label>
                              <ColorSetter
                                color={tableBodyBgColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('tableBodyBgColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Product name color')}</label>
                              <ColorSetter
                                color={productNameColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('productNameColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          {showProductAttribute && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Product attributes color')}</label>
                                <ColorSetter
                                  color={productAttributesColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('productAttributesColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Price color')}</label>
                              <ColorSetter
                                color={reducedPriceColor || '#f042a8'}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('reducedPriceColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          {showOldPrice && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Old price color')}</label>
                                <ColorSetter
                                  color={oldPriceColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('oldPriceColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showRemoveProductButton && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Remove button color')}</label>
                                <ColorSetter
                                  color={removeButtonTextColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('removeButtonTextColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          {showRemoveProductButton && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Remove button background color')}</label>
                                <ColorSetter
                                  color={removeButtonBackgroundColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('removeButtonBackgroundColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.summaryStyling && (
                    <li className={this.state.currentDrop === 30 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(30)}>
                        <Icon icon={this.state.currentDrop === 30 ? 'dropup' : 'dropdown'} />
                        {l('Foot colors')}
                      </div>
                      {this.state.currentDrop === 30 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Text color')}</label>
                              <ColorSetter
                                color={tableFootColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('tableFootColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Background color')}</label>
                              <ColorSetter
                                color={tableFootBgColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('tableFootBgColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                          {showCartExpiringTimer && (
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Remove button background color')}</label>
                                <ColorSetter
                                  color={cartExpiringTimerColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('cartExpiringTimerColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          )}
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Total price color')}</label>
                              <ColorSetter
                                color={priceTotalColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasOne('priceTotalColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.imageSettings && (
                    <>
                      <li className='active'>
                        <div className='head'>{l('Image "alt" attribute value')}</div>
                        <div className='body'>
                          <TextField
                            dark
                            placeholder={l('alt attribute')}
                            value={altAttribute || ''}
                            onChange={(text) => {
                              this._changedDatasOne('altAttribute', text);
                            }}
                          />
                        </div>
                      </li>
                      <li className={'active'}>
                        <div className='head'>{l('Image size')}</div>

                        <div className='body'>
                          <div className='gk-custom-message'>
                            {l('If the image is larger than the container it will be maximised by 100%')}
                          </div>
                          <div className='section'>
                            <label className='small'>{l('Size')}</label>
                            <ul className='inline-options dark grow'>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('sizeMode', 'image');
                                }}
                                className={sizeMode !== 'custom' ? 'selected' : ''}
                              >
                                <span>{l('Original')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('sizeMode', 'custom');
                                }}
                                className={sizeMode === 'custom' ? 'selected' : ''}
                              >
                                <span>{l('Custom')}</span>
                              </li>
                            </ul>
                          </div>
                          {sizeMode == 'custom' && (
                            <div className='section'>
                              <label className='small'>{l('Width')}</label>
                              <SliderRange
                                value={imageWidth || 100}
                                min={5}
                                max={1200}
                                onChange={(value) => {
                                  this._changedDatasOne('imageWidth', value);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.overlayText && (
                    <li>
                      <div className='head'>{l('Overlay Text')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Show Text')}</label>
                            <Switch
                              checked={isTextOverlay || false}
                              onChange={(event) => {
                                this._changedDatasOne('isTextOverlay', event.target.checked);
                              }}
                            />
                          </div>
                          {isTextOverlay && (
                            <>
                              <label className='small'>{l('Enter Text (H3)')}</label>
                              <br />
                              <TextField
                                dark
                                placeholder={l('Overlay Text')}
                                value={textOverlay || ''}
                                onChange={(text) => {
                                  this._changedDatasOne('textOverlay', text);
                                }}
                              />
                              <br />
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Color')}</label>
                                <ColorSetter
                                  color={textOverlayColor || ''}
                                  onChangeComplete={(color) => {
                                    this._changedDatasOne('textOverlayColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.labelSettings && (
                    <li>
                      <div className='head'>{l('Label') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Click Here')}
                            value={linkLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('linkLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.iconSettings && (
                    <li>
                      <div className='head'>{l('Icon settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Icon')}</label>
                            <button
                              className={`dark gk-button gk-default gk-small gk-${useIcon ? 'primary' : 'secondary'}`}
                              onClick={() => {
                                this._changedDatasOne('useIcon', useIcon ? !useIcon : true);
                              }}
                            >
                              <span>{l('Link has icon')}</span>
                            </button>
                          </div>
                        </div>

                        {useIcon && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Icon position')}</label>

                              <Select
                                value={iconPosition || 'left'}
                                onChange={(value) => {
                                  this._changedDatasOne('iconPosition', value);
                                }}
                                options={[
                                  { label: l('Left'), value: 'left' },
                                  { label: l('Right'), value: 'right' },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        )}
                        {useIcon && (
                          <div className='section'>
                            <label className='small'>{l('Spacing in between (px)')}</label>

                            <SliderRange
                              value={iconSpacing || 6}
                              min={6}
                              max={64}
                              onChange={(value) => {
                                this._changedDatasOne('iconSpacing', value);
                              }}
                            />
                          </div>
                        )}
                        {useIcon && (
                          <div className='section'>
                            <label className='small'>{l('Icons list')}</label>
                            <TextField
                              placeholder='Search Icon'
                              value={this.state.searchIcon || ''}
                              onChange={(value) => {
                                this.setState({ searchIcon: value });
                              }}
                              dark
                            />
                            <div className='fa-icon-container'>
                              {iconsList.map(
                                (icon, index) =>
                                  icon[1].match(new RegExp(this.state.searchIcon, 'i')) && (
                                    <span
                                      className={(iconClass === icon && 'active') || ''}
                                      key={index}
                                      onClick={() => {
                                        this._changedDatasOne('iconClass', icon);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={[icon[0], icon[1]]} />
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  {availableSettings.linkSettings && (
                    <li>
                      <div className='head'>{l('Link settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <ul className='inline-options dark grow'>
                            <li
                              onClick={() => {
                                this._changedDatasOne('linkTarget', '_self');
                              }}
                              className={linkTarget !== '_blank' ? 'selected' : ''}
                            >
                              <span>{l('Same window')}</span>
                            </li>
                            <li
                              onClick={() => {
                                this._changedDatasOne('linkTarget', '_blank');
                              }}
                              className={linkTarget === '_blank' ? 'selected' : ''}
                            >
                              <span>{l('New window')}</span>
                            </li>
                          </ul>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Link type')}</label>
                            <Select
                              placeholder={l('Link type')}
                              value={linkType || ''}
                              onChange={(value) => {
                                this._changedDatasOne('linkType', value);
                              }}
                              options={[
                                {
                                  label: l('Custom'),
                                  value: 'custom',
                                },
                                {
                                  label: l('Product'),
                                  value: 'product',
                                },
                                {
                                  label: l('Category'),
                                  value: 'category',
                                },
                                {
                                  label: l('Page'),
                                  value: 'cms',
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                        {linkType === 'product' && (
                          <div className='section'>
                            <ProductFilter
                              label={l('Filter product')}
                              list={url && url.includes('product__') ? url.replace('product__', '') : ''}
                              onCheck={(product) => {
                                this._changedDatasOne('url_' + this.props.currentLang, 'product__' + product);
                              }}
                            />
                          </div>
                        )}
                        {linkType === 'category' && (
                          <div className='section'>
                            <label className='small'>{l('Select a category')}</label>
                            <ListSortedItemsCheckboxes
                              list={url && url.includes('category__') ? url.replace('category__', '') : ''}
                              onCheck={(list) => {
                                this._changedDatasOne('url_' + this.props.currentLang, 'category__' + list);
                              }}
                              items={this.props.fetchedCategories.leveled}
                              inlineItems={this.props.fetchedCategories.normal}
                            />
                          </div>
                        )}
                        {linkType === 'cms' && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Page')}</label>
                              <Select
                                placeholder={l('Select page')}
                                value={url && url.includes('cms__') ? url : ''}
                                onChange={(value) => {
                                  this._changedDatasOne('url_' + this.props.currentLang, value);
                                }}
                                options={pagesOptions('cms')}
                                dark
                              />
                            </div>
                          </div>
                        )}
                        {linkType === 'custom' && (
                          <div className='section'>
                            <TextField
                              placeholder={l('Custom url')}
                              info={l('Secured link is recommanded')}
                              value={
                                this.state.url && this.state.url.includes('custom__')
                                  ? this.state.url.replace('custom__', '')
                                  : this.state.url
                              }
                              onChange={(value) => {
                                if (validURL(value)) {
                                  this._changedDatasOne('url_' + this.props.currentLang, 'custom__' + value);
                                }
                                this.setState({ url: value });
                              }}
                              dark
                              error={
                                !validURL(
                                  this.state.url && this.state.url.includes('custom__')
                                    ? this.state.url.replace('custom__', '')
                                    : this.state.url
                                )
                                  ? l('Url format not correct')
                                  : false
                              }
                            />
                          </div>
                        )}
                        {linkType === 'popup' && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Popup')}</label>
                              <Select
                                placeholder={l('Select popup')}
                                value={url && url.includes('modal_payload__') ? url : ''}
                                onChange={(value) => {
                                  this._changedDatasOne('url_' + this.props.currentLang, value);
                                }}
                                options={pagesOptions('modal_payload')}
                                dark
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}
                  {availableSettings.listSettings && (
                    <li className={'active'}>
                      <div className='head'>{l('List element')}</div>

                      <div className='body'>
                        <button
                          className='new-item'
                          onClick={() => {
                            newDraggableElement(this.state.datas.listItems, 'listItems', 'Item', (elements) => {
                              this._changedDatasOne('listItems', elements);
                            });
                          }}
                        >
                          <Icon icon='plus' />
                        </button>
                        <div className='section'>
                          {(listItems && listItems.length > 0 && (
                            <DragSortableList
                              dropBackTransitionDuration={0.3}
                              dragType='list'
                              type='vertical'
                              size='small'
                              items={listItems}
                              placeholder={placeholder}
                              currentLang={this.props.currentLang}
                              icons={{
                                move: <Icon icon='move' />,
                                dots: <Icon icon='dots' />,
                              }}
                              onSort={(sortedList, dropEvent) => {
                                this._changedDatasOne('listItems', sortedList);
                              }}
                              onEdit={(itemId) => {
                                this.state.datas.listItems.forEach((slide) => {
                                  if (itemId.toString() === slide.id) this.setState({ listDatas: slide });
                                });
                              }}
                              onRemove={(itemId) => {
                                this._removeItem(itemId, 'listItems');
                              }}
                            />
                          )) || (
                            <div className='gk-warning-message'>
                              <p>{l('Add your first item')}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.newsletterFieldTextSettings && (
                    <li>
                      <div className='head'>{l('Text field settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            label={l('Text field placeholder') + ' (' + getLangLabel() + ')'}
                            placeholder={l('Placeholder')}
                            info={l('Secured link is recommanded')}
                            value={
                              (newsletterSettings && newsletterSettings['flPlaceholder_' + this.props.currentLang]) ||
                              ''
                            }
                            onChange={(value) => {
                              this._changedDatasTwo(
                                'newsletterSettings',
                                'flPlaceholder_' + this.props.currentLang,
                                value
                              );
                            }}
                            dark
                            required
                            solid
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.newsletterButtonLabelSettings && (
                    <li>
                      <div className='head'>{l('Button settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            label={l('Button label') + ' (' + getLangLabel() + ')'}
                            placeholder={l('Subscribe')}
                            value={
                              (newsletterSettings && newsletterSettings['btnLabel_' + this.props.currentLang]) || ''
                            }
                            onChange={(value) => {
                              this._changedDatasTwo('newsletterSettings', 'btnLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                            solid
                          />
                        </div>

                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Icon')}</label>
                            <button
                              className={`dark gk-button gk-default gk-small gk-${
                                newsletterSettings && newsletterSettings.useButtonIcon ? 'primary' : 'secondary'
                              }`}
                              onClick={() => {
                                this._changedDatasTwo(
                                  'newsletterSettings',
                                  'useButtonIcon',
                                  newsletterSettings && newsletterSettings.useButtonIcon
                                    ? !newsletterSettings.useButtonIcon
                                    : true
                                );
                              }}
                            >
                              <span>{l('Button has icon')}</span>
                            </button>
                          </div>
                        </div>

                        {newsletterSettings && newsletterSettings.useButtonIcon && (
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Icon position')}</label>

                              <Select
                                value={(newsletterSettings && newsletterSettings.buttonIconPosition) || 'left'}
                                onChange={(value) => {
                                  this._changedDatasTwo('newsletterSettings', 'buttonIconPosition', value);
                                }}
                                options={[
                                  { label: l('Left'), value: 'left' },
                                  { label: l('Right'), value: 'right' },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        )}

                        {newsletterSettings && newsletterSettings.useButtonIcon && (
                          <div className='section'>
                            <label className='small'>{l('Icons list')}</label>
                            <TextField
                              placeholder={l('Search Icon')}
                              value={this.state.searchIcon || ''}
                              onChange={(value) => {
                                this.setState({ searchIcon: value });
                              }}
                              dark
                            />
                            <div className='fa-icon-container'>
                              {iconsList.map(
                                (icon, index) =>
                                  icon[1].match(new RegExp(this.state.searchIcon, 'i')) && (
                                    <span
                                      className={
                                        (newsletterSettings &&
                                          newsletterSettings.buttonIconClass === icon &&
                                          'active') ||
                                        ''
                                      }
                                      key={index}
                                      onClick={() => {
                                        this._changedDatasTwo('newsletterSettings', 'buttonIconClass', icon);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={[icon[0], icon[1]]} />
                                    </span>
                                  )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  )}

                  {availableSettings.buttonlabelSettings && (
                    <li>
                      <div className='head'>{l('Label') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Subscribe')}
                            value={linkLabel}
                            onChange={(value) => {
                              this._changedDatasOne('linkLabel_' + this.props.currentLang, value);
                            }}
                            dark
                            required
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.oldProductPricingLabelSettings && (
                    <li className={this.state.currentDrop === 56 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(56)}>
                        <Icon icon={this.state.currentDrop === 56 ? 'dropup' : 'dropdown'} />
                        {l('Label for old price')}{' '}
                        {productPricingSettings && productPricingSettings.labelBeforeOldPrice
                          ? '"' + productPricingSettings.labelBeforeOldPrice + '"'
                          : ''}
                      </div>
                      {this.state.currentDrop === 56 && (
                        <div className='body'>
                          <div className='section'>
                            <TextField
                              label={l('Label') + ' (' + getLangLabel() + ')'}
                              placeholder={l('Was')}
                              value={
                                (productPricingSettings &&
                                  productPricingSettings['labelBeforeOldPrice_' + this.props.currentLang]) ||
                                (productPricingSettings && productPricingSettings['labelBeforeOldPrice']) ||
                                ''
                              }
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'labelBeforeOldPrice_' + this.props.currentLang,
                                  value,
                                  () => {
                                    this._changedDatasTwo('productPricingSettings', 'labelBeforeOldPrice', value);
                                  }
                                );
                              }}
                              dark
                              required
                              solid
                            />
                          </div>

                          <div className='section'>
                            <Select
                              value={(productPricingSettings && productPricingSettings.oldPriceLabelFontFamilyId) || ''}
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'oldPriceLabelFontFamilyId',
                                  value,
                                  () => {
                                    this._changedDatasTwo(
                                      'productPricingSettings',
                                      'oldPriceLabelFontFamily',
                                      this.fontList[value].cssName
                                    );
                                  }
                                );
                              }}
                              placeholder={l('Google font')}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className='section'>
                            <label className='small'>{l('Size')}</label>
                            <SliderRange
                              value={(productPricingSettings && productPricingSettings.oldPriceLabelFontSize) || 16}
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'oldPriceLabelFontSize', value);
                              }}
                            />
                          </div>

                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <Select
                                value={(productPricingSettings && productPricingSettings.oldPriceLabelFontWeight) || ''}
                                onChange={(value) => {
                                  this._changedDatasTwo('productPricingSettings', 'oldPriceLabelFontWeight', value);
                                }}
                                placeholder={l('Font weight')}
                                options={this._fontsWeightOptions(
                                  (productPricingSettings && productPricingSettings.oldPriceLabelFontFamilyId) || '',
                                  (productPricingSettings && productPricingSettings.oldPriceLabelFontFamily) || ''
                                )}
                                dark
                              />

                              <ColorSetter
                                color={productPricingSettings.oldPriceLabelColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasTwo('productPricingSettings', 'oldPriceLabelColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className='section'>
                            <Select
                              value={productPricingSettings && productPricingSettings.oldPriceLabelLetterSpacing}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'oldPriceLabelLetterSpacing', value);
                              }}
                              placeholder={l('Letter spacing')}
                              options={[
                                {
                                  label: l('Tight'),
                                  value: -1,
                                },
                                {
                                  label: l('Normal'),
                                  value: '0',
                                },
                                {
                                  label: l('Wide'),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.oldProductPricingSettings && (
                    <li className={this.state.currentDrop === 54 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(54)}>
                        <Icon icon={this.state.currentDrop === 54 ? 'dropup' : 'dropdown'} />
                        {l('Old price font settings')}
                      </div>
                      {this.state.currentDrop === 54 && (
                        <div className='body'>
                          <div className='section'>
                            <Select
                              value={(productPricingSettings && productPricingSettings.oldPriceFontFamilyId) || ''}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'oldPriceFontFamilyId', value, () => {
                                  this._changedDatasTwo(
                                    'productPricingSettings',
                                    'oldPriceFontFamily',
                                    this.fontList[value].cssName
                                  );
                                });
                              }}
                              placeholder={l('Google font')}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className='section'>
                            <label className='small'>{l('Size')}</label>
                            <SliderRange
                              value={(productPricingSettings && productPricingSettings.oldPriceFontSize) || 16}
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'oldPriceFontSize', value);
                              }}
                            />
                          </div>

                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <Select
                                value={(productPricingSettings && productPricingSettings.oldPriceFontWeight) || ''}
                                onChange={(value) => {
                                  this._changedDatasTwo('productPricingSettings', 'oldPriceFontWeight', value);
                                }}
                                placeholder={l('Font weight')}
                                options={this._fontsWeightOptions(
                                  (productPricingSettings && productPricingSettings.oldPriceFontFamilyId) || '',
                                  (productPricingSettings && productPricingSettings.oldPriceFontFamily) || ''
                                )}
                                dark
                              />

                              <ColorSetter
                                color={productPricingSettings.oldPriceColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasTwo('productPricingSettings', 'oldPriceColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className='section'>
                            <Select
                              value={productPricingSettings && productPricingSettings.oldPriceLetterSpacing}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'oldPriceLetterSpacing', value);
                              }}
                              placeholder={l('Letter spacing')}
                              options={[
                                {
                                  label: l('Tight'),
                                  value: -1,
                                },
                                {
                                  label: l('Normal'),
                                  value: '0',
                                },
                                {
                                  label: l('Wide'),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.currentProductPricingLabelSettings && (
                    <li className={this.state.currentDrop === 57 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(57)}>
                        <Icon icon={this.state.currentDrop === 57 ? 'dropup' : 'dropdown'} />
                        {l('Label for current price')}{' '}
                        {productPricingSettings && productPricingSettings.labelBeforeCurrentPrice
                          ? '"' + productPricingSettings.labelBeforeCurrentPrice + '"'
                          : ''}
                      </div>
                      {this.state.currentDrop === 57 && (
                        <div className='body'>
                          <div className='section'>
                            <TextField
                              label={l('Label') + ' (' + getLangLabel() + ')'}
                              placeholder={l('Now')}
                              value={
                                (productPricingSettings &&
                                  productPricingSettings['labelBeforeCurrentPrice_' + this.props.currentLang]) ||
                                (productPricingSettings && productPricingSettings['labelBeforeCurrentPrice']) ||
                                ''
                              }
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'labelBeforeCurrentPrice_' + this.props.currentLang,
                                  value,
                                  () => {
                                    this._changedDatasTwo('productPricingSettings', 'labelBeforeCurrentPrice', value);
                                  }
                                );
                              }}
                              dark
                              required
                              solid
                            />
                          </div>

                          <div className='section'>
                            <Select
                              value={
                                (productPricingSettings && productPricingSettings.currentPriceLabelFontFamilyId) || ''
                              }
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'currentPriceLabelFontFamilyId',
                                  value,
                                  () => {
                                    this._changedDatasTwo(
                                      'productPricingSettings',
                                      'currentPriceLabelFontFamily',
                                      this.fontList[value].cssName
                                    );
                                  }
                                );
                              }}
                              placeholder={l('Google font')}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className='section'>
                            <label className='small'>{l('Size')}</label>
                            <SliderRange
                              value={(productPricingSettings && productPricingSettings.currentPriceLabelFontSize) || 16}
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'currentPriceLabelFontSize', value);
                              }}
                            />
                          </div>

                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <Select
                                value={
                                  (productPricingSettings && productPricingSettings.currentPriceLabelFontWeight) || ''
                                }
                                onChange={(value) => {
                                  this._changedDatasTwo('productPricingSettings', 'currentPriceLabelFontWeight', value);
                                }}
                                placeholder={l('Font weight')}
                                options={this._fontsWeightOptions(
                                  (productPricingSettings && productPricingSettings.currentPriceLabelFontFamilyId) ||
                                    '',
                                  (productPricingSettings && productPricingSettings.currentPriceLabelFontFamily) || ''
                                )}
                                dark
                              />

                              <ColorSetter
                                color={productPricingSettings.currentPriceLabelColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasTwo('productPricingSettings', 'currentPriceLabelColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className='section'>
                            <Select
                              value={productPricingSettings && productPricingSettings.currentPriceLabelLetterSpacing}
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'currentPriceLabelLetterSpacing',
                                  value
                                );
                              }}
                              placeholder={l('Letter spacing')}
                              options={[
                                {
                                  label: l('Tight'),
                                  value: -1,
                                },
                                {
                                  label: l('Normal'),
                                  value: '0',
                                },
                                {
                                  label: l('Wide'),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.currentProductPricingSettings && (
                    <li className={this.state.currentDrop === 55 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(55)}>
                        <Icon icon={this.state.currentDrop === 55 ? 'dropup' : 'dropdown'} />
                        {l('Current price font settings')}
                      </div>
                      {this.state.currentDrop === 55 && (
                        <div className='body'>
                          <div className='section'>
                            <Select
                              value={(productPricingSettings && productPricingSettings.currentPriceFontFamilyId) || ''}
                              onChange={(value) => {
                                this._changedDatasTwo(
                                  'productPricingSettings',
                                  'currentPriceFontFamilyId',
                                  value,
                                  () => {
                                    this._changedDatasTwo(
                                      'productPricingSettings',
                                      'currentPriceFontFamily',
                                      this.fontList[value].cssName
                                    );
                                  }
                                );
                              }}
                              placeholder={l('Google font')}
                              options={this._fontsFamilyOptions()}
                              dark
                            />
                          </div>

                          <div className='section'>
                            <label className='small'>{l('Size')}</label>
                            <SliderRange
                              value={(productPricingSettings && productPricingSettings.currentPriceFontSize) || 16}
                              min={10}
                              max={100}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'currentPriceFontSize', value);
                              }}
                            />
                          </div>

                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <Select
                                value={(productPricingSettings && productPricingSettings.currentPriceFontWeight) || ''}
                                onChange={(value) => {
                                  this._changedDatasTwo('productPricingSettings', 'currentPriceFontWeight', value);
                                }}
                                placeholder={l('Font weight')}
                                options={this._fontsWeightOptions(
                                  (productPricingSettings && productPricingSettings.currentPriceFontFamilyId) || '',
                                  (productPricingSettings && productPricingSettings.currentPriceFontFamily) || ''
                                )}
                                dark
                              />

                              <ColorSetter
                                color={productPricingSettings.currentPriceColor || ''}
                                onChangeComplete={(color) => {
                                  this._changedDatasTwo('productPricingSettings', 'currentPriceColor', color);
                                }}
                                right
                              />
                            </div>
                          </div>

                          <div className='section'>
                            <Select
                              value={productPricingSettings && productPricingSettings.currentPriceLetterSpacing}
                              onChange={(value) => {
                                this._changedDatasTwo('productPricingSettings', 'currentPriceLetterSpacing', value);
                              }}
                              placeholder={l('Letter spacing')}
                              options={[
                                {
                                  label: l('Tight'),
                                  value: -1,
                                },
                                {
                                  label: l('Normal'),
                                  value: '0',
                                },
                                {
                                  label: l('Wide'),
                                  value: 1,
                                },
                              ]}
                              dark
                            />
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.buttonAnimation && (
                    <li>
                      <div className='head'>{l('Animation')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Animation')}</label>
                            <Select
                              placeholder={l('Animations')}
                              value={buttonAnimation || ''}
                              onChange={(value) => {
                                this._changedDatasOne('buttonAnimation', value);
                              }}
                              options={this.animations}
                              nullable
                              nullablePlaceholder={l('No animation')}
                              dark
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.buttonWidth && (
                    <li>
                      <div className='head'>{l('Full width')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Full width')}</label>
                            <Switch
                              checked={buttonFullWidth}
                              onChange={(e) => {
                                this._changedDatasOne('buttonFullWidth', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.buttonAnimation && (
                    <li>
                      <div className='head'>{l('Custom Fields')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Postion related to add to cart button')}</label>
                            <Select
                              placeholder={l('Before')}
                              value={customField || 0}
                              onChange={(value) => {
                                this._changedDatasOne('customField', value);
                              }}
                              options={this.customFields}
                              nullable
                              nullablePlaceholder={l('No custom fields')}
                              dark
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.variationSettings && (
                    <li>
                      <div className='head'>{l('Label color')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Label color')}</label>
                            <ColorSetter
                              color={variationsLabelColor || '#000000'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('variationsLabelColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.variationSettings && (
                    <li>
                      <div className='head'>{l('Variation color')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Background color')}</label>
                            <ColorSetter
                              color={variationsBgColor || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('variationsBgColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Text color')}</label>
                            <ColorSetter
                              color={variationsColor || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('variationsColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.variationSettings && (
                    <li>
                      <div className='head'>{l('Selected variation color')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Background color')}</label>
                            <ColorSetter
                              color={variationsBgColorHover || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('variationsBgColorHover', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Text color')}</label>
                            <ColorSetter
                              color={variationsColorHover || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('variationsColorHover', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.checkoutSummaryStyling && (
                    <li>
                      <div className='head'>{l('Price color')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Text color')}</label>
                            <ColorSetter
                              color={priceColor || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('priceColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.checkoutSummaryStyling && (
                    <li>
                      <div className='head'>{l('Table settings')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Backrgound color')}</label>
                            <ColorSetter
                              color={tableBgColor || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('tableBgColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Border color')}</label>
                            <ColorSetter
                              color={tableBorderColor || ''}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('tableBorderColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.fontAwesomeIcon && (
                    <li>
                      <div className='head'>{l('Icon')}</div>
                      <div className='body'>
                        <div className='section'>
                          <label className='small'>{l('Icons list')}</label>
                          <TextField
                            placeholder={l('Search Icon')}
                            value={this.state.searchIcon || ''}
                            onChange={(value) => {
                              this.setState({ searchIcon: value });
                            }}
                            dark
                          />
                          <div className='fa-icon-container'>
                            {iconsList.map(
                              (icon, index) =>
                                icon[1].match(new RegExp(this.state.searchIcon, 'i')) && (
                                  <span
                                    className={(iconClass === icon && 'active') || ''}
                                    key={index}
                                    onClick={() => {
                                      this._changedDatasOne('iconClass', icon);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={[icon[0], icon[1]]} />
                                  </span>
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.qtyDiscounts && (
                    <li>
                      <div className='head'>{l('Title') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Leave empty to hide')}
                            value={labelQD}
                            onChange={(value) => {
                              this._changedDatasOne('labelQD_' + this.props.currentLang, value);
                            }}
                            dark
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {(availableSettings.categoryProducts || availableSettings.relatedProducts) && (
                    <li className={this.state.currentDrop === 31 ? 'active' : ''}>
                      <div className='head' onClick={() => this._dropDown(31)}>
                        <Icon icon={this.state.currentDrop === 31 ? 'dropup' : 'dropdown'} />
                        {l('Products per row')}
                      </div>
                      {this.state.currentDrop === 31 && (
                        <div className='body'>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Desktop')}</label>

                              <Select
                                value={relProductsPerRowLg || 3}
                                onChange={(value) => {
                                  this._changedDatasOne('relProductsPerRowLg', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Horizontal Tab')}</label>

                              <Select
                                value={relProductsPerRowMd || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('relProductsPerRowMd', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Vertical Tab')}</label>

                              <Select
                                value={relProductsPerRowSm || 4}
                                onChange={(value) => {
                                  this._changedDatasOne('relProductsPerRowSm', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                          <div className='section'>
                            <div className='gk-form-row-container'>
                              <label className='small'>{l('Mobile')}</label>

                              <Select
                                value={relProductsPerRowXs || 6}
                                onChange={(value) => {
                                  this._changedDatasOne('relProductsPerRowXs', value);
                                }}
                                options={[
                                  { label: l('1 product'), value: 12 },
                                  { label: l('2 Products'), value: 6 },
                                  { label: l('3 Products'), value: 4 },
                                  { label: l('4 Products'), value: 3 },
                                  { label: l('6 Products'), value: 2 },
                                ]}
                                dark
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  )}
                  {availableSettings.htmlCode && (
                    <li>
                      <div className='head'>{l('Html code') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <TextField
                            placeholder={l('Your code here...')}
                            value={htmlCode}
                            onChange={(value) => {
                              this._changedDatasOne('htmlCode_' + this.props.currentLang, value);
                            }}
                            multiline={true}
                            dark
                            style={{ height: '100%' }}
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.globalSettings && (
                    <>
                      {(inArray('EZSCONF_FB_APP_ID', availableSettings.globalSettings) ||
                        inArray('EZSCONF_FB_PAGE_ID', availableSettings.globalSettings)) && (
                        <li>
                          <div className='head'>{l('FB settings')}</div>
                          <div className='body'>
                            {inArray('EZSCONF_FB_APP_ID', availableSettings.globalSettings) && (
                              <div className='section'>
                                <TextField
                                  value={this.state.globalSettings.EZSCONF_FB_APP_ID || ''}
                                  label='APP_ID'
                                  onChange={(value) => {
                                    this._changedGlobalSettings('EZSCONF_FB_APP_ID', value);
                                  }}
                                  dark
                                  solid
                                />
                              </div>
                            )}
                            {inArray('EZSCONF_FB_PAGE_ID', availableSettings.globalSettings) && (
                              <div className='section'>
                                <TextField
                                  value={this.state.globalSettings.EZSCONF_FB_PAGE_ID || ''}
                                  label='PAGE_ID'
                                  onChange={(value) => {
                                    this._changedGlobalSettings('EZSCONF_FB_PAGE_ID', value);
                                  }}
                                  dark
                                  solid
                                />
                              </div>
                            )}
                          </div>
                        </li>
                      )}

                      {/* {inArray(
                        "GK_ONEPAGE_CHECKOUT",
                        availableSettings.globalSettings
                      ) && (
                        <>
                          <li>
                            <div className="head">{l("Checkout Types")}</div>
                            <div className="body">
                              {inArray(
                                "GK_ONEPAGE_CHECKOUT",
                                availableSettings.globalSettings
                              ) && (
                                <div className="section">
                                  <Select
                                    dark
                                    value={
                                      (this.state.globalSettings.GK_ONEPAGE_CHECKOUT?.toString() &&
                                        (
                                          this.state.globalSettings
                                            .GK_ONEPAGE_CHECKOUT + 1
                                        ).toString()) ||
                                      null
                                    }
                                    onChange={(value) => {
                                      this._changedGlobalSettings(
                                        "GK_ONEPAGE_CHECKOUT",
                                        value - 1,
                                        () => {
                                          GKEvent.updateState(
                                            "GK_ONEPAGE_CHECKOUT",
                                            value - 1
                                          );
                                        }
                                      );
                                    }}
                                    placeholder={l("Please select")}
                                    options={[
                                      { label: l("Please Select"), value: "0" },
                                      { label: l("Multi page"), value: "1" },
                                      { label: l("One page"), value: "2" },
                                    ]}
                                  />
                                </div>
                              )}
                            </div>
                          </li>
                        </>
                      )} */}

                      {Object.keys(availableSettings.globalSettings).length > 3 && (
                        <>
                          <li>
                            <div className='head'>{l('Registration')}</div>
                            <div className='body'>
                              <div className='section'>
                                <div className='gk-form-row-container'>
                                  <label className='small'>{l('Email')}</label>
                                  <Switch
                                    checked={this.state.globalSettings.GK_CHECKOUT_EMAIL_ACTIVE == '1' ? true : false}
                                    readOnly
                                  />
                                </div>
                                <div className='gk-form-row-container'>
                                  <label className='small'>{l('SMS')}</label>
                                  <Switch
                                    checked={this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE == '1' ? true : false}
                                    onChange={(e) => {
                                      console.log(e.target.checked);
                                      const value = e.target.checked;
                                      this._changedGlobalSettings('GK_CHECKOUT_MOBILE_ACTIVE', value, () => {
                                        GKEvent.updateState('GK_CHECKOUT_MOBILE_ACTIVE', value);
                                      });
                                    }}
                                  />
                                </div>
                                {this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE == '1' && (
                                  <div className='section'>
                                    <label className='small'>Twilio SID</label>
                                    <TextField
                                      value={this.state.globalSettings.GK_TWILIO_ACCOUNT_SID || ''}
                                      placeholder={'Twilio SID'}
                                      dark
                                      onChange={(value) => {
                                        console.log(value);
                                        this._changedGlobalSettings('GK_TWILIO_ACCOUNT_SID', value, () => {
                                          GKEvent.updateState('GK_TWILIO_ACCOUNT_SID', value);
                                        });
                                      }}
                                      required
                                    />
                                  </div>
                                )}
                                {this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE == '1' && (
                                  <div className='section'>
                                    <label className='small'>Twilio Token</label>
                                    <TextField
                                      value={this.state.globalSettings.GK_TWILIO_AUTH_TOKEN || ''}
                                      placeholder={'Twilio Token'}
                                      dark
                                      onChange={(value) => {
                                        console.log(value);
                                        this._changedGlobalSettings('GK_TWILIO_AUTH_TOKEN', value, () => {
                                          GKEvent.updateState('GK_TWILIO_AUTH_TOKEN', value);
                                        });
                                      }}
                                      required
                                    />
                                  </div>
                                )}
                                {this.state.globalSettings.GK_CHECKOUT_MOBILE_ACTIVE == '1' && (
                                  <div className='section'>
                                    <label className='small'>Twilio Phone number</label>
                                    <TextField
                                      value={this.state.globalSettings.GK_TWILIO_PHONE_NUMBER || ''}
                                      placeholder={'Twilio Phone number'}
                                      dark
                                      onChange={(value) => {
                                        this._changedGlobalSettings('GK_TWILIO_PHONE_NUMBER', value, () => {
                                          GKEvent.updateState('GK_TWILIO_PHONE_NUMBER', value);
                                        });
                                      }}
                                      required
                                      error={
                                        !isValidMobile(this.state.globalSettings.GK_TWILIO_PHONE_NUMBER)
                                          ? 'Enter Valid Mobile Number'
                                          : ''
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className='head'>{l('Address Settings')}</div>
                            <div className='body'>
                              {/* {inArray(
                                  "EZCONF_SHOW_PH_NUMBER_DISPLAY",
                                  availableSettings.globalSettings
                                ) && (
                                    <div className="section">
                                      <div className="gk-form-row-container">
                                        <label className="small">
                                          {l("Capture Phone Number")}
                                        </label>

                                        <Switch
                                          checked={
                                            this.state.globalSettings
                                              .EZCONF_SHOW_PH_NUMBER_DISPLAY == "1"
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            const value = e.target.checked;
                                            this._changedGlobalSettings(
                                              "EZCONF_SHOW_PH_NUMBER_DISPLAY",
                                              value,
                                              () => {
                                                if (!value)
                                                  this._changedGlobalSettings(
                                                    "EZCONF_SHOW_PH_NUMBER_REQUIRED",
                                                    value,
                                                    () => {
                                                      GKEvent.updateState(
                                                        "EZCONF_SHOW_PH_NUMBER_REQUIRED",
                                                        value
                                                      );
                                                    }
                                                  );
                                                GKEvent.updateState(
                                                  "EZCONF_SHOW_PH_NUMBER_DISPLAY",
                                                  value
                                                );
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )} */}
                              {inArray('EZCONF_SHOW_PH_NUMBER_REQUIRED', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Phone Number is Required')}</label>

                                    <Switch
                                      checked={
                                        this.state.globalSettings.EZCONF_SHOW_PH_NUMBER_REQUIRED == '1' ? true : false
                                      }
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('EZCONF_SHOW_PH_NUMBER_REQUIRED', value, () => {
                                          if (value)
                                            this._changedGlobalSettings('EZCONF_SHOW_PH_NUMBER_DISPLAY', value, () => {
                                              GKEvent.updateState('EZCONF_SHOW_PH_NUMBER_DISPLAY', value);
                                            });
                                          GKEvent.updateState('EZCONF_SHOW_PH_NUMBER_REQUIRED', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {inArray('SHOW_CHECKOUT_ORDER_NOTE', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Enable Order Comment')}</label>

                                    <Switch
                                      checked={this.state.globalSettings.SHOW_CHECKOUT_ORDER_NOTE == '1' ? true : false}
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('SHOW_CHECKOUT_ORDER_NOTE', value, () => {
                                          if (!value) {
                                            this._changedGlobalSettings(
                                              'SHOW_CHECKOUT_ORDER_NOTE_REQUIRE',
                                              value,
                                              () => {
                                                GKEvent.updateState('SHOW_CHECKOUT_ORDER_NOTE_REQUIRE', value);
                                              }
                                            );
                                          }
                                          GKEvent.updateState('SHOW_CHECKOUT_ORDER_NOTE', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {inArray('SHOW_CHECKOUT_ORDER_NOTE_REQUIRE', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Order comment is required')}</label>

                                    <Switch
                                      checked={
                                        this.state.globalSettings.SHOW_CHECKOUT_ORDER_NOTE_REQUIRE == '1' ? true : false
                                      }
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('SHOW_CHECKOUT_ORDER_NOTE_REQUIRE', value, () => {
                                          if (value) {
                                            this._changedGlobalSettings('SHOW_CHECKOUT_ORDER_NOTE', value, () => {
                                              GKEvent.updateState('SHOW_CHECKOUT_ORDER_NOTE', value);
                                            });
                                          }
                                          GKEvent.updateState('SHOW_CHECKOUT_ORDER_NOTE_REQUIRE', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {inArray('EZCONF_SHOW_INSTANT_DISCOUNT', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Visibility of coupon field')}</label>

                                    <Switch
                                      checked={
                                        this.state.globalSettings.EZCONF_SHOW_INSTANT_DISCOUNT == '1' ? true : false
                                      }
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('EZCONF_SHOW_INSTANT_DISCOUNT', value, () => {
                                          GKEvent.updateState('EZCONF_SHOW_INSTANT_DISCOUNT', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {inArray('EZSCONF_PRECHECK_OPTIONS', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Precheck Options by default')}</label>

                                    <Switch
                                      checked={this.state.globalSettings.EZSCONF_PRECHECK_OPTIONS == '1' ? true : false}
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('EZSCONF_PRECHECK_OPTIONS', value, () => {
                                          GKEvent.updateState('EZSCONF_PRECHECK_OPTIONS', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {inArray('EZCONF_SHOW_NEWSLETTER', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Newsletter subscription')}</label>

                                    <Switch
                                      checked={this.state.globalSettings.EZCONF_SHOW_NEWSLETTER == '1' ? true : false}
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('EZCONF_SHOW_NEWSLETTER', value, () => {
                                          GKEvent.updateState('EZCONF_SHOW_NEWSLETTER', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {/* {inArray(
                                  "EZSCONF_SET_CHECKBOXES_POSITION",
                                  availableSettings.globalSettings
                                ) && (
                                    <div className="section">
                                      <div className="gk-form-row-container">
                                        <label className="small">
                                          {l(
                                            "Above/Below Continue button position"
                                          )}
                                        </label>

                                        <Switch
                                          checked={
                                            this.state.globalSettings
                                              .EZSCONF_SET_CHECKBOXES_POSITION ==
                                              "1"
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            const value = e.target.checked;
                                            this._changedGlobalSettings(
                                              "EZSCONF_SET_CHECKBOXES_POSITION",
                                              value,
                                              () => {
                                                GKEvent.updateState(
                                                  "EZSCONF_SET_CHECKBOXES_POSITION",
                                                  value
                                                );
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )} */}
                              {inArray('GK_PRICE_AFTER_TEXT', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <div className='gk-form-row-container'>
                                    <label className='small'>{l('Show price after label')}</label>

                                    <Switch
                                      checked={this.state.globalSettings.GK_PRICE_AFTER_TEXT == '1' ? true : false}
                                      onChange={(e) => {
                                        const value = e.target.checked;
                                        this._changedGlobalSettings('GK_PRICE_AFTER_TEXT', value, () => {
                                          GKEvent.updateState('GK_PRICE_AFTER_TEXT', value);
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {inArray('GK_PAYMENT_TEXT', availableSettings.globalSettings) && (
                                <div className='section'>
                                  <TextField
                                    placeholder={l('Pay button label')}
                                    value={this.state.globalSettings.GK_PAYMENT_TEXT}
                                    onChange={(value) => {
                                      this._changedGlobalSettings('GK_PAYMENT_TEXT', value, () => {
                                        GKEvent.updateState('GK_PAYMENT_TEXT', value);
                                      });
                                    }}
                                    dark
                                  />
                                </div>
                              )}
                              <div className='section text-center'>
                                <button
                                  className='gk-button gk-small gk-primary gk-default'
                                  onClick={() => this._setGlobalSetting(l('Setting saved successfully'))}
                                >
                                  <span>{l('Save')}</span>
                                </button>
                              </div>
                            </div>
                          </li>
                        </>
                      )}
                    </>
                  )}
                  {availableSettings.totalCartPrice && (
                    <li>
                      <div className='head'>{l('Label') + ' (' + getLangLabel() + ')'}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-custom-message'>
                            <p>
                              {l('Please add')} <strong>%%</strong>{' '}
                              {l('it will be automatically replaced by the value')}
                            </p>
                          </div>
                        </div>
                        <div className='section'>
                          <TextField
                            value={cartPriceLabel || ''}
                            onChange={(value) => {
                              this._changedDatasOne('cartPriceLabel_' + this.props.currentLang, value);
                            }}
                            dark
                          />
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.totalCartPrice && (
                    <li>
                      <div className='head'>{l('Price color')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Price color')}</label>
                            <ColorSetter
                              color={cartPriceColor || '#a94442'}
                              onChangeComplete={(color) => {
                                this._changedDatasOne('cartPriceColor', color);
                              }}
                              right
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {availableSettings.totalCartPrice && (
                    <li>
                      <div className='head'>{l('Price to calculate')}</div>
                      <div className='body'>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Total value of Product')}</label>
                            <Switch
                              checked={totalCart_product}
                              onChange={(e) => {
                                this._changedDatasOne('totalCart_product', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Total value of Shipping')}</label>
                            <Switch
                              checked={totalCart_shipping}
                              onChange={(e) => {
                                this._changedDatasOne('totalCart_shipping', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className='section'>
                          <div className='gk-form-row-container'>
                            <label className='small'>{l('Total value of Tax')}</label>
                            <Switch
                              checked={totalCart_tax}
                              onChange={(e) => {
                                this._changedDatasOne('totalCart_tax', e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.collapseSettings && (
                    <>
                      <li>
                        <div className='head'>{l('Heading Tag (SEO)')}</div>
                        <div className='body'>
                          <div className='section'>
                            <ul className='inline-options dark grow'>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h1');
                                }}
                                className={headingTag && headingTag === 'h1' ? 'selected' : ''}
                              >
                                <span>{l('H1')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h2');
                                }}
                                className={headingTag && headingTag === 'h2' ? 'selected' : ''}
                              >
                                <span>{l('H2')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h3');
                                }}
                                className={headingTag && headingTag === 'h3' ? 'selected' : ''}
                              >
                                <span>{l('H3')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h4');
                                }}
                                className={headingTag && headingTag === 'h4' ? 'selected' : ''}
                              >
                                <span>{l('H4')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h5');
                                }}
                                className={headingTag && headingTag === 'h5' ? 'selected' : ''}
                              >
                                <span>{l('H5')}</span>
                              </li>
                              <li
                                onClick={() => {
                                  this._changedDatasOne('headingTag', 'h6');
                                }}
                                className={headingTag && headingTag === 'h6' ? 'selected' : ''}
                              >
                                <span>{l('H6')}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className='head'>{l('Heading Text')}</div>
                        <div className='body'>
                          <div className='section'>
                            <TextField
                              placeholder={'Heading Text'}
                              value={headingText || ''}
                              onChange={(value) => {
                                this._changedDatasOne('headingText', value);
                              }}
                              dark
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className='body'>
                          <div className='section'>
                            <label className='small'>{l('Show open/closed?')}</label>
                            <Select
                              dark
                              options={[
                                { value: 1, label: 'closed' },
                                { value: 2, label: 'open' },
                              ]}
                              value={collapseOpen + 1}
                              onChange={(value) => {
                                this._changedDatasOne('collapseOpen', value - 1);
                              }}
                            />
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                  {availableSettings.tabsSettings && tabs && (
                    <li>
                      <div className='head'>{l('Tabs')}</div>
                      <div className='body'>
                        <button
                          className='new-item'
                          onClick={() => {
                            newTabItem(this.state.datas.tabs, 'tabs', 'Tab', (elements) => {
                              this._changedDatasOne('tabs', elements);
                            });
                          }}
                        >
                          <Icon icon='plus' />
                        </button>
                        <div className='section'>
                          <DragSortableList
                            dropBackTransitionDuration={0.3}
                            type='vertical'
                            size='normal'
                            dragType='slider'
                            items={tabs}
                            placeholder={placeholder}
                            currentLang={this.props.currentLang}
                            icons={{
                              move: <Icon icon='move' />,
                              dots: <Icon icon='dots' />,
                            }}
                            onEdit={this._editTab}
                            onRemove={(itemId) => {
                              this._removeItem(itemId, 'tabs');
                            }}
                            onSort={(sortedList, dropEvent) => {
                              this._changedDatasOne('tabs', sortedList);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  )}

                  {availableSettings.tabsSettings && (
                    <>
                      {availableSettings.tabsSettings.tabColor && (
                        <li>
                          <div className='body'>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Tab color')}</label>
                                <ColorSetter
                                  color={tabColor || '#ffffff'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasTwo('tabsSettings', 'tabColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      {availableSettings.tabsSettings.activeTabColor && (
                        <li>
                          <div className='body'>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Active tab color')}</label>
                                <ColorSetter
                                  color={activeTabColor || '#ffffff'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasTwo('tabsSettings', 'activeTabColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      {availableSettings.tabsSettings.tabTextColor && (
                        <li>
                          <div className='body'>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Tab text color')}</label>
                                <ColorSetter
                                  color={tabTextColor || '#ffffff'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasTwo('tabsSettings', 'tabTextColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      {availableSettings.tabsSettings.activeTabTextColor && (
                        <li>
                          <div className='body'>
                            <div className='section'>
                              <div className='gk-form-row-container'>
                                <label className='small'>{l('Active tab text color')}</label>
                                <ColorSetter
                                  color={activeTabTextColor || '#ffffff'}
                                  onChangeComplete={(color) => {
                                    this._changedDatasTwo('tabsSettings', 'activeTabTextColor', color);
                                  }}
                                  right
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </div>
            </div>
          )}
        </>
      );
    } else return false;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FloatElementSettings);

class TabDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tab: null,
    };
  }

  componentDidMount() {
    this.setState({ tab: this.props.tab });
  }

  _saveTab = () => {
    // console.log("saving");
    this.props.onSave(this.state.tab);
  };

  _changeField = (field, value) => {
    const tab = this.state.tab;
    this.setState({ tab: { ...tab, data: { ...tab.data, [field]: value } } });
  };

  render() {
    return (
      <div className='slide-dialog'>
        <div className='head'>
          <Icon icon='time' onClick={this.props.onClose} /> <h3>{l('Edit item')}</h3>
          <button className='new-item' onClick={this._saveTab}>
            <Icon icon='check' />
          </button>
        </div>

        <div className='form'>
          <div className='section'>
            <TextField
              label={l('Title')}
              solid
              dark
              value={this.state.tab && this.state.tab.data && this.state.tab.data['title_' + this.props.currentLang]}
              onChange={(value) => {
                this._changeField('title_' + this.props.currentLang, value);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
